import "./style.css";
import { defineComponent as b, openBlock as c, createElementBlock as p, Fragment as T, createBlock as y, resolveDynamicComponent as j, mergeProps as C, toHandlers as x, withCtx as N, renderSlot as A, resolveComponent as k, createTextVNode as bt, toDisplayString as te, defineAsyncComponent as H, createVNode as R, renderList as V, createCommentVNode as v, h as Ae, createElementVNode as q, normalizeStyle as F, normalizeClass as z, markRaw as gt } from "vue";
const yt = /* @__PURE__ */ new Set(["area", "base", "br", "col", "embed", "hr", "img", "input", "keygen", "link", "meta", "param", "source", "track", "wbr"]), kt = (e) => typeof e == "string" && yt.has(e.toLowerCase());
function W(e = {}, t, n) {
  const o = {};
  for (const r in e) {
    if (!e[r] || n && !r.startsWith(t))
      continue;
    const i = n ? r.replace(t, "") : r;
    o[i] = e[r];
  }
  return o;
}
const vt = b({
  name: "dynamic-renderer",
  props: ["TagName", "attributes", "actionAttributes"],
  data() {
    return { isEmptyElement: kt };
  }
}), g = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [o, r] of t)
    n[o] = r;
  return n;
};
function St(e, t, n, o, r, i) {
  return e.isEmptyElement(e.TagName) ? (c(), y(j(e.TagName), C({ key: 1 }, e.attributes, x(e.actionAttributes)), null, 16)) : (c(), p(T, { key: 0 }, [
    typeof e.TagName == "string" ? (c(), y(j(e.TagName), C({ key: 0 }, e.attributes, x(e.actionAttributes)), {
      default: N(() => [
        A(e.$slots, "default")
      ]),
      _: 3
    }, 16)) : (c(), y(j(e.TagName), C({ key: 1 }, e.attributes, x(e.actionAttributes)), {
      default: N(() => [
        A(e.$slots, "default")
      ]),
      _: 3
    }, 16))
  ], 64));
}
const pe = /* @__PURE__ */ g(vt, [["render", St]]), Ni = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: pe
}, Symbol.toStringTag, { value: "Module" })), P = "vue", _ = () => {
  switch (P) {
    case "react":
    case "reactNative":
    case "rsc":
      return "className";
    case "svelte":
    case "vue":
    case "solid":
    case "qwik":
    case "angular":
      return "class";
  }
}, Ct = b({
  name: "builder-button",
  components: { DynamicRenderer: pe },
  props: [
    "attributes",
    "link",
    "openLinkInNewTab",
    "builderLinkComponent",
    "text"
  ],
  data() {
    return { filterAttrs: W };
  },
  methods: {
    attrs() {
      return {
        ...W(this.attributes, "v-on:", !1),
        [_()]: `${this.link ? "" : "builder-button"} ${this.attributes[_()] || ""}`,
        ...this.link ? {
          href: this.link,
          target: this.openLinkInNewTab ? "_blank" : void 0,
          role: "link"
        } : {
          role: "button"
        }
      };
    }
  }
});
function wt(e, t, n, o, r, i) {
  const s = k("DynamicRenderer");
  return c(), y(s, {
    attributes: e.attrs(),
    TagName: e.link ? e.builderLinkComponent || "a" : "button",
    actionAttributes: e.filterAttrs(e.attributes, "v-on:", !0)
  }, {
    default: N(() => [
      bt(te(e.text), 1)
    ]),
    _: 1
  }, 8, ["attributes", "TagName", "actionAttributes"]);
}
const Tt = /* @__PURE__ */ g(Ct, [["render", wt]]), It = Symbol(), le = {
  Builder: {
    content: null,
    context: {},
    localState: void 0,
    rootSetState() {
    },
    rootState: {},
    apiKey: null,
    apiVersion: void 0,
    componentInfos: {},
    inheritedStyles: {},
    BlocksWrapper: "div",
    BlocksWrapperProps: {},
    nonce: ""
  },
  key: It
}, $t = Symbol(), Ve = {
  Components: { registeredComponents: {} },
  key: $t
};
function Rt(e) {
  var t;
  return {
    ...(t = e.component) == null ? void 0 : t.options,
    ...e.options
  };
}
function Et(e, ...t) {
  const n = Object.assign({}, e);
  for (const o of t)
    delete n[o];
  return n;
}
const Q = "[Builder.io]: ", E = {
  log: (...e) => console.log(Q, ...e),
  error: (...e) => console.error(Q, ...e),
  warn: (...e) => console.warn(Q, ...e),
  debug: (...e) => console.debug(Q, ...e)
}, We = (e, t, n) => {
  const o = String.prototype.split.call(t, /[,[\].]+?/).filter(Boolean).reduce((r, i) => r != null ? r[i] : r, e);
  return o === void 0 || o === e ? n : o;
};
function $() {
  return typeof window < "u" && typeof document < "u";
}
const Pt = (e) => {
  const t = {};
  return e.forEach((n, o) => {
    t[o] = n;
  }), t;
}, Ne = (e) => e instanceof URLSearchParams ? Pt(e) : e, Oe = (e) => typeof e == "string" ? e : e instanceof URLSearchParams ? e.toString() : new URLSearchParams(e).toString();
function Bt() {
  return $() && window.self !== window.top;
}
function B(e) {
  return Bt() && // accessing window.location.search is safe here because `isIframe()` is only `true` if we're in a browser.
  Oe(e || window.location.search).indexOf("builder.frameEditing=") !== -1;
}
const xt = () => {
  if ($()) {
    const e = new URL(location.href);
    return e.pathname === "" && (e.pathname = "/"), e;
  } else
    return console.warn("Cannot get location for tracking in non-browser environment"), null;
}, At = () => typeof navigator == "object" && navigator.userAgent || "", Fe = () => {
  const e = At(), t = {
    Android() {
      return e.match(/Android/i);
    },
    BlackBerry() {
      return e.match(/BlackBerry/i);
    },
    iOS() {
      return e.match(/iPhone|iPod/i);
    },
    Opera() {
      return e.match(/Opera Mini/i);
    },
    Windows() {
      return e.match(/IEMobile/i) || e.match(/WPDesktop/i);
    },
    any() {
      return t.Android() || t.BlackBerry() || t.iOS() || t.Opera() || t.Windows() || P === "reactNative";
    }
  }, n = e.match(/Tablet|iPad/i), o = xt();
  return {
    urlPath: o == null ? void 0 : o.pathname,
    host: (o == null ? void 0 : o.host) || (o == null ? void 0 : o.hostname),
    device: n ? "tablet" : t.any() ? "mobile" : "desktop"
  };
}, Vt = ({
  builder: e,
  context: t,
  event: n,
  state: o
}) => Object.entries({
  state: o,
  Builder: e,
  // legacy
  builder: e,
  context: t,
  event: n
}), Wt = () => ({
  isEditing: B(),
  isBrowser: $(),
  isServer: !$(),
  getUserAttributes: () => Fe()
}), Nt = (e, {
  isExpression: t = !0
}) => /* we disable this for cases where we definitely don't want a return */ t && !(e.includes(";") || e.includes(" return ") || e.trim().startsWith("return ")) ? `return (${e});` : e;
function De({
  rootState: e,
  localState: t,
  rootSetState: n
}) {
  return new Proxy(e, {
    get: (o, r) => {
      if (t && r in t)
        return t[r];
      const i = o[r];
      return typeof i == "object" && i !== null ? De({
        rootState: i,
        localState: void 0,
        rootSetState: n ? (s) => {
          o[r] = s, n(o);
        } : void 0
      }) : i;
    },
    set: (o, r, i) => {
      if (t && r in t)
        throw new Error("Writing to local state is not allowed as it is read-only.");
      return o[r] = i, n == null || n(o), !0;
    }
  });
}
const Ce = ({
  code: e,
  builder: t,
  context: n,
  event: o,
  localState: r,
  rootSetState: i,
  rootState: s
}) => {
  const l = Vt({
    builder: t,
    context: n,
    event: o,
    state: De({
      rootState: s,
      localState: r,
      rootSetState: i
    })
  });
  return new Function(...l.map(([a]) => a), e)(...l.map(([, a]) => a));
}, D = (e) => e != null;
function Ot() {
  var e;
  return typeof process < "u" && D((e = process == null ? void 0 : process.versions) == null ? void 0 : e.node);
}
const Ft = ({
  shouldLogWarning: e
}) => {
  var r;
  if (!Ot())
    return !1;
  const t = process.arch === "arm64", n = process.version.startsWith("v20"), o = (r = process.env.NODE_OPTIONS) == null ? void 0 : r.includes("--no-node-snapshot");
  return t && n && !o ? (e && E.log("Skipping usage of `isolated-vm` to avoid crashes in Node v20 on an arm64 machine.\n    If you would like to use the `isolated-vm` package on this machine, please provide the `NODE_OPTIONS=--no-node-snapshot` config to your Node process.\n    See https://github.com/BuilderIO/builder/blob/main/packages/sdks/README.md#node-v20--m1-macs-apple-silicon-support for more information.\n    "), !0) : !1;
}, Dt = (e) => ($() || Ft({
  shouldLogWarning: !0
}), Ce(e)), Lt = /^(return )?(\s*)?state(?<getPath>(\.\w+)+)(\s*);?$/, Ut = /(\s)*var(\s)+_virtual_index(\s)*=(\s)*state(?<getPath>(\.\w+)+)(\s*);?(\s)*return(\s)*_virtual_index(\s)*/, Mt = (e) => {
  var t, n, o, r, i, s;
  return ((o = (n = (t = Lt.exec(e.trim())) == null ? void 0 : t.groups) == null ? void 0 : n.getPath) == null ? void 0 : o.slice(1)) || ((s = (i = (r = Ut.exec(e.trim())) == null ? void 0 : r.groups) == null ? void 0 : i.getPath) == null ? void 0 : s.slice(1));
};
function J({
  code: e,
  context: t,
  localState: n,
  rootState: o,
  rootSetState: r,
  event: i,
  isExpression: s = !0
}) {
  if (e.trim() === "")
    return;
  const l = Mt(e.trim());
  if (l)
    return We({
      ...o,
      ...n
    }, l);
  const a = {
    code: Nt(e, {
      isExpression: s
    }),
    builder: Wt(),
    context: t,
    event: i,
    rootSetState: r,
    rootState: o,
    localState: n
  };
  try {
    return Dt(a);
  } catch (u) {
    E.error("Failed code evaluation: " + u.message, {
      code: e
    });
    return;
  }
}
const me = (e) => JSON.parse(JSON.stringify(e)), Le = (e, t, n) => {
  if (Object(e) !== e)
    return e;
  const o = Array.isArray(t) ? t : t.toString().match(/[^.[\]]+/g);
  return o.slice(0, -1).reduce((r, i, s) => Object(r[i]) === r[i] ? r[i] : r[i] = Math.abs(Number(o[s + 1])) >> 0 === +o[s + 1] ? [] : {}, e)[o[o.length - 1]] = n, e;
};
function ce(e) {
  if (e === null || typeof e != "object")
    return e;
  if (Array.isArray(e))
    return e.map((n) => ce(n));
  if (e["@type"] === "@builder.io/sdk:Element")
    return e;
  const t = {};
  for (const n in e)
    n !== "meta" && Object.prototype.hasOwnProperty.call(e, n) && (t[n] = ce(e[n]));
  return t;
}
const Ht = ["svelte", "vue", "angular", "qwik", "solid"].includes(P), jt = (e) => {
  if (Ht) {
    const t = me(e);
    return {
      ...t,
      properties: {
        ...t.properties
      },
      actions: {
        ...t.actions
      }
    };
  } else {
    const t = ce(Et(e, "children", "meta"));
    return {
      ...t,
      properties: {
        ...t.properties
      },
      actions: {
        ...t.actions
      },
      children: e.children,
      meta: e.meta
    };
  }
}, Kt = ({
  block: e,
  context: t,
  localState: n,
  rootState: o,
  rootSetState: r
}) => {
  if (!e.bindings)
    return e;
  const i = jt(e);
  for (const s in e.bindings) {
    const l = e.bindings[s], a = J({
      code: l,
      localState: n,
      rootState: o,
      rootSetState: r,
      context: t
    });
    Le(i, s, a);
  }
  return i;
};
function qt({
  block: e,
  context: t,
  shouldEvaluateBindings: n,
  localState: o,
  rootState: r,
  rootSetState: i
}) {
  const s = e;
  return n ? Kt({
    block: s,
    localState: o,
    rootState: r,
    rootSetState: i,
    context: t
  }) : s;
}
function zt(e) {
  const t = e || ($() ? window.location.search : void 0);
  return t ? Oe(t).indexOf("builder.preview=") !== -1 : !1;
}
const Gt = (e) => ({
  type: "builder.registerComponent",
  data: ee(e)
}), Jt = (e) => {
  const t = e.toString().trim(), n = /^[a-zA-Z0-9_]+\s*=>/i.test(t);
  return `return (${!t.startsWith("function") && !t.startsWith("(") && !n ? "function " : ""}${t}).apply(this, arguments)`;
};
function ee(e) {
  return JSON.parse(JSON.stringify(e, (t, n) => typeof n == "function" ? Jt(n) : n));
}
const we = {};
function Yt(e, t) {
  e === "plugin" && (t = ee(t));
  let n = we[e];
  if (n || (n = we[e] = []), n.push(t), $()) {
    const o = {
      type: "builder.register",
      data: {
        type: e,
        info: t
      }
    };
    try {
      parent.postMessage(o, "*"), parent !== window && window.postMessage(o, "*");
    } catch (r) {
      console.debug("Could not postmessage", r);
    }
  }
}
const Te = {};
function Oi(e) {
  if ($()) {
    Object.assign(Te, e);
    const t = {
      type: "builder.settingsChange",
      data: Te
    };
    parent.postMessage(t, "*");
  }
}
const Ie = "builder.", Xt = "options.", Ue = (e) => {
  if (!e)
    return {};
  const t = Ne(e), n = {};
  return Object.keys(t).forEach((o) => {
    if (o.startsWith(Ie)) {
      const r = o.replace(Ie, "").replace(Xt, "");
      n[r] = t[o];
    }
  }), n;
}, Qt = () => {
  if (!$())
    return {};
  const e = new URLSearchParams(window.location.search);
  return Ue(e);
}, Me = "2.0.31", He = () => ({
  "X-Builder-SDK": P,
  "X-Builder-SDK-GEN": "2",
  "X-Builder-SDK-Version": Me
}), Zt = (e) => {
  if (e === "localhost" || e === "127.0.0.1")
    return e;
  const t = e.split(".");
  return t.length > 2 ? t.slice(1).join(".") : e;
}, je = ({
  name: e,
  canTrack: t
}) => {
  var n;
  try {
    return t ? (n = document.cookie.split("; ").find((o) => o.startsWith(`${e}=`))) == null ? void 0 : n.split("=")[1] : void 0;
  } catch (o) {
    E.warn("[COOKIE] GET error: ", (o == null ? void 0 : o.message) || o);
    return;
  }
}, Ke = async (e) => je(e), _t = (e) => e.map(([t, n]) => n ? `${t}=${n}` : t).filter(D).join("; "), en = [["secure", ""], ["SameSite", "None"]], tn = ({
  name: e,
  value: t,
  expires: n
}) => {
  const r = ($() ? location.protocol === "https:" : !0) ? en : [[]], i = n ? [["expires", n.toUTCString()]] : [[]], s = [[e, t], ...i, ["path", "/"], ["domain", Zt(window.location.hostname)], ...r];
  return _t(s);
}, qe = async ({
  name: e,
  value: t,
  expires: n,
  canTrack: o
}) => {
  try {
    if (!o)
      return;
    const r = tn({
      name: e,
      value: t,
      expires: n
    });
    document.cookie = r;
  } catch (r) {
    E.warn("[COOKIE] SET error: ", (r == null ? void 0 : r.message) || r);
  }
};
function nn() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(e) {
    const t = Math.random() * 16 | 0;
    return (e == "x" ? t : t & 3 | 8).toString(16);
  });
}
function ze() {
  return nn().replace(/-/g, "");
}
const Ge = "builderSessionId", on = async ({
  canTrack: e
}) => {
  if (!e)
    return;
  const t = await Ke({
    name: Ge,
    canTrack: e
  });
  if (D(t))
    return t;
  {
    const n = rn();
    return sn({
      id: n,
      canTrack: e
    }), n;
  }
}, rn = () => ze(), sn = ({
  id: e,
  canTrack: t
}) => qe({
  name: Ge,
  value: e,
  canTrack: t
}), Je = () => $() && typeof localStorage < "u" ? localStorage : void 0, an = ({
  key: e,
  canTrack: t
}) => {
  var n;
  try {
    return t ? (n = Je()) == null ? void 0 : n.getItem(e) : void 0;
  } catch (o) {
    console.debug("[LocalStorage] GET error: ", o);
    return;
  }
}, ln = ({
  key: e,
  canTrack: t,
  value: n
}) => {
  var o;
  try {
    t && ((o = Je()) == null || o.setItem(e, n));
  } catch (r) {
    console.debug("[LocalStorage] SET error: ", r);
  }
}, Ye = "builderVisitorId", cn = ({
  canTrack: e
}) => {
  if (!e)
    return;
  const t = an({
    key: Ye,
    canTrack: e
  });
  if (D(t))
    return t;
  {
    const n = dn();
    return un({
      id: n,
      canTrack: e
    }), n;
  }
}, dn = () => ze(), un = ({
  id: e,
  canTrack: t
}) => ln({
  key: Ye,
  value: e,
  canTrack: t
});
function he(e) {
  var t;
  typeof process < "u" && ((t = process.env) != null && t.DEBUG) && String(process.env.DEBUG) == "true" && E.log(e);
}
const pn = async ({
  canTrack: e
}) => {
  if (!e)
    return {
      visitorId: void 0,
      sessionId: void 0
    };
  const t = await on({
    canTrack: e
  }), n = cn({
    canTrack: e
  });
  return {
    sessionId: t,
    visitorId: n
  };
}, mn = async ({
  type: e,
  canTrack: t,
  apiKey: n,
  metadata: o,
  ...r
}) => ({
  type: e,
  data: {
    ...r,
    metadata: {
      url: location.href,
      ...o
    },
    ...await pn({
      canTrack: t
    }),
    userAttributes: Fe(),
    ownerId: n
  }
});
async function de({
  apiHost: e,
  ...t
}) {
  if (!t.apiKey) {
    E.error("Missing API key for track call. Please provide your API key.");
    return;
  }
  if (!t.canTrack || B() || !($() || P === "reactNative"))
    return;
  const o = `${e || "https://cdn.builder.io"}/api/v1/track`;
  return he(o), fetch(o, {
    method: "POST",
    body: JSON.stringify({
      events: [await mn(t)]
    }),
    headers: {
      "content-type": "application/json",
      ...He()
    },
    mode: "cors"
  }).catch((r) => {
    console.error("Failed to track: ", r);
  });
}
const Fi = (e) => de({
  ...e,
  canTrack: !0
}), hn = ["*.beta.builder.io", "beta.builder.io", "builder.io", "localhost", "qa.builder.io"];
function Xe(e, t) {
  if (!t.origin.startsWith("http") && !t.origin.startsWith("https"))
    return !1;
  const n = new URL(t.origin), o = n.hostname;
  return (e || hn).findIndex((r) => r.startsWith("*.") ? o.endsWith(r.slice(1)) : r === o) > -1;
}
const fn = () => {
  Yt("insertMenu", {
    name: "_default",
    default: !0,
    items: [{
      name: "Box"
    }, {
      name: "Text"
    }, {
      name: "Image"
    }, {
      name: "Columns"
    }, {
      name: "Core:Section"
    }, {
      name: "Core:Button"
    }, {
      name: "Embed"
    }, {
      name: "Custom Code"
    }]
  });
};
let $e = !1;
const Qe = (e = {}) => {
  var t, n;
  $e || ($e = !0, $() && ((t = window.parent) == null || t.postMessage({
    type: "builder.sdkInfo",
    data: {
      target: P,
      version: Me,
      supportsPatchUpdates: !1,
      // Supports builder-model="..." attribute which is needed to
      // scope our '+ add block' button styling
      supportsAddBlockScoping: !0,
      supportsCustomBreakpoints: !0
    }
  }, "*"), (n = window.parent) == null || n.postMessage({
    type: "builder.updateContent",
    data: {
      options: e
    }
  }, "*"), window.addEventListener("message", (o) => {
    var i, s;
    if (!Xe(e.trustedHosts, o))
      return;
    const {
      data: r
    } = o;
    if (r != null && r.type)
      switch (r.type) {
        case "builder.evaluate": {
          const l = r.data.text, a = r.data.arguments || [], u = r.data.id, m = new Function(l);
          let h, d = null;
          try {
            h = m.apply(null, a);
          } catch (f) {
            d = f;
          }
          d ? (i = window.parent) == null || i.postMessage({
            type: "builder.evaluateError",
            data: {
              id: u,
              error: d.message
            }
          }, "*") : h && typeof h.then == "function" ? h.then((f) => {
            var S;
            (S = window.parent) == null || S.postMessage({
              type: "builder.evaluateResult",
              data: {
                id: u,
                result: f
              }
            }, "*");
          }).catch(console.error) : (s = window.parent) == null || s.postMessage({
            type: "builder.evaluateResult",
            data: {
              result: h,
              id: u
            }
          }, "*");
          break;
        }
      }
  })));
}, Ze = ({
  model: e,
  trustedHosts: t,
  callbacks: n
}) => (o) => {
  if (!Xe(t, o))
    return;
  const {
    data: r
  } = o;
  if (r)
    switch (r.type) {
      case "builder.configureSdk": {
        n.configureSdk(r.data);
        break;
      }
      case "builder.triggerAnimation": {
        n.animation(r.data);
        break;
      }
      case "builder.contentUpdate": {
        const i = r.data, s = i.key || i.alias || i.entry || i.modelName, l = i.data;
        s === e && n.contentUpdate(l);
        break;
      }
    }
}, Di = (e, t, n) => {
  if (!$)
    return E.warn("`subscribeToEditor` only works in the browser. It currently seems to be running on the server."), () => {
    };
  Qe();
  const o = Ze({
    callbacks: {
      contentUpdate: t,
      animation: () => {
      },
      configureSdk: () => {
      }
    },
    model: e,
    trustedHosts: n == null ? void 0 : n.trustedHosts
  });
  return window.addEventListener("message", o), () => {
    window.removeEventListener("message", o);
  };
}, bn = "builder.tests", fe = (e) => `${bn}.${e}`, gn = ({
  contentId: e
}) => Ke({
  name: fe(e),
  canTrack: !0
}), yn = ({
  contentId: e
}) => je({
  name: fe(e),
  canTrack: !0
}), kn = ({
  contentId: e,
  value: t
}) => qe({
  name: fe(e),
  value: t,
  canTrack: !0
}), _e = (e) => D(e.id) && D(e.variations) && Object.keys(e.variations).length > 0, vn = ({
  id: e,
  variations: t
}) => {
  var r;
  let n = 0;
  const o = Math.random();
  for (const i in t) {
    const s = (r = t[i]) == null ? void 0 : r.testRatio;
    if (n += s, o < n)
      return i;
  }
  return e;
}, et = (e) => {
  const t = vn(e);
  return kn({
    contentId: e.id,
    value: t
  }).catch((n) => {
    E.error("could not store A/B test variation: ", n);
  }), t;
}, tt = ({
  item: e,
  testGroupId: t
}) => {
  const n = e.variations[t];
  return t === e.id || // handle edge-case where `testGroupId` points to non-existing variation
  !n ? {
    testVariationId: e.id,
    testVariationName: "Default"
  } : {
    data: n.data,
    testVariationId: n.id,
    testVariationName: n.name || (n.id === e.id ? "Default" : "")
  };
}, Sn = ({
  item: e,
  canTrack: t
}) => {
  if (!t)
    return e;
  if (!e)
    return;
  if (!_e(e))
    return e;
  const n = yn({
    contentId: e.id
  }) || et({
    variations: e.variations,
    id: e.id
  }), o = tt({
    item: e,
    testGroupId: n
  });
  return {
    ...e,
    ...o
  };
}, Cn = async ({
  item: e,
  canTrack: t
}) => {
  if (!t || !_e(e))
    return e;
  const o = await gn({
    contentId: e.id
  }) || et({
    variations: e.variations,
    id: e.id
  }), r = tt({
    item: e,
    testGroupId: o
  });
  return {
    ...e,
    ...r
  };
}, G = (e) => D(e) ? e : !0;
function wn() {
  return typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : globalThis;
}
function Tn() {
  const e = wn().fetch;
  if (typeof e > "u")
    throw console.warn(`Builder SDK could not find a global fetch function. Make sure you have a polyfill for fetch in your project. 
      For more information, read https://github.com/BuilderIO/this-package-uses-fetch`), new Error("Builder SDK could not find a global `fetch` function");
  return e;
}
const In = Tn();
function ue(e, t = null, n = ".") {
  return Object.keys(e).reduce((o, r) => {
    const i = e[r], s = [t, r].filter(Boolean).join(n);
    return [typeof i == "object", i !== null, !(Array.isArray(i) && i.length === 0)].every(Boolean) ? {
      ...o,
      ...ue(i, s, n)
    } : {
      ...o,
      [s]: i
    };
  }, {});
}
function nt(e, t, n = {}) {
  for (const o in e) {
    const r = e[o], i = t ? t + "." + o : o;
    r && typeof r == "object" && !Array.isArray(r) && !Object.keys(r).find((s) => s.startsWith("$")) ? nt(r, i, n) : n[i] = r;
  }
  return n;
}
const $n = "v3", Re = (e) => typeof e == "number" && !isNaN(e) && e >= 0, be = (e) => {
  const {
    limit: t = 30,
    userAttributes: n,
    query: o,
    model: r,
    apiKey: i,
    enrich: s,
    locale: l,
    apiVersion: a = $n,
    fields: u,
    omit: m,
    offset: h,
    cacheSeconds: d,
    staleCacheSeconds: f,
    sort: S,
    includeUnpublished: w,
    apiHost: L
  } = e;
  if (!i)
    throw new Error("Missing API key");
  if (!["v3"].includes(a))
    throw new Error(`Invalid apiVersion: expected 'v3', received '${a}'`);
  const mt = t !== 1, ht = L || "https://cdn.builder.io", I = new URL(`${ht}/api/${a}/content/${r}`);
  I.searchParams.set("apiKey", i), I.searchParams.set("limit", String(t)), I.searchParams.set("noTraverse", String(mt)), I.searchParams.set("includeRefs", String(!0));
  const ne = l || (n == null ? void 0 : n.locale);
  let X = n;
  if (ne && (I.searchParams.set("locale", ne), X = {
    locale: ne,
    ...X
  }), s && I.searchParams.set("enrich", String(s)), I.searchParams.set("omit", m || "meta.componentsUsed"), u && I.searchParams.set("fields", u), Number.isFinite(h) && h > -1 && I.searchParams.set("offset", String(Math.floor(h))), typeof w == "boolean" && I.searchParams.set("includeUnpublished", String(w)), d && Re(d) && I.searchParams.set("cacheSeconds", String(d)), f && Re(f) && I.searchParams.set("staleCacheSeconds", String(f)), S) {
    const O = ue({
      sort: S
    });
    for (const M in O)
      I.searchParams.set(M, JSON.stringify(O[M]));
  }
  const ft = {
    ...Qt(),
    ...Ne(e.options || {})
  }, Se = ue(ft);
  for (const O in Se)
    I.searchParams.set(O, String(Se[O]));
  if (X && I.searchParams.set("userAttributes", JSON.stringify(X)), o) {
    const O = nt({
      query: o
    });
    for (const M in O)
      I.searchParams.set(M, JSON.stringify(O[M]));
  }
  return I;
}, Rn = (e) => "results" in e;
async function ge(e) {
  const t = await Bn({
    ...e,
    limit: 1
  });
  return t && t[0] || null;
}
const En = async (e) => {
  var s;
  const t = be(e), n = e.fetch ?? In, o = {
    ...e.fetchOptions,
    headers: {
      ...(s = e.fetchOptions) == null ? void 0 : s.headers,
      ...He()
    }
  };
  return await (await n(t.href, o)).json();
}, Pn = async (e, t, n = be(e)) => {
  const o = G(e.canTrack);
  if (n.search.includes("preview="), !o || !($() || P === "reactNative"))
    return t.results;
  try {
    const r = [];
    for (const i of t.results)
      r.push(await Cn({
        item: i,
        canTrack: o
      }));
    t.results = r;
  } catch (r) {
    E.error("Could not process A/B tests. ", r);
  }
  return t.results;
};
async function Bn(e) {
  try {
    const t = be(e), n = await En(e);
    return Rn(n) ? Pn(e, n) : (E.error("Error fetching data. ", {
      url: t,
      content: n,
      options: e
    }), null);
  } catch (t) {
    return E.error("Error fetching data. ", t), null;
  }
}
const Li = async (e) => {
  var o, r, i;
  const t = e.path || ((o = e.url) == null ? void 0 : o.pathname) || ((r = e.userAttributes) == null ? void 0 : r.urlPath), n = {
    ...e,
    apiKey: e.apiKey,
    model: e.model || "page",
    userAttributes: {
      ...e.userAttributes,
      ...t ? {
        urlPath: t
      } : {}
    },
    options: Ue(e.searchParams || ((i = e.url) == null ? void 0 : i.searchParams) || e.options)
  };
  return {
    apiKey: n.apiKey,
    model: n.model,
    content: await ge(n)
  };
}, ye = (e) => e ? e.replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, "$1-$2").toLowerCase() : "";
function xn(e, t, n = {}) {
  let o, r, i, s = null, l = 0;
  const a = function() {
    l = n.leading === !1 ? 0 : Date.now(), s = null, i = e.apply(o, r), s || (o = r = null);
  };
  return function() {
    const u = Date.now();
    !l && n.leading === !1 && (l = u);
    const m = t - (u - l);
    return o = this, r = arguments, m <= 0 || m > t ? (s && (clearTimeout(s), s = null), l = u, i = e.apply(o, r), s || (o = r = null)) : !s && n.trailing !== !1 && (s = setTimeout(a, m)), i;
  };
}
function K(e, ...t) {
  const n = Object(e);
  for (let o = 1; o < arguments.length; o++) {
    const r = arguments[o];
    if (r != null)
      for (const i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (n[i] = r[i]);
  }
  return n;
}
function An(e) {
  for (const t of e)
    switch (t.trigger) {
      case "pageLoad":
        it(t);
        break;
      case "scrollInView":
        Wn(t);
        break;
    }
}
function ot(e) {
  console.warn(`Cannot animate element: element with ID ${e} not found!`);
}
function rt(e, t) {
  const n = Vn(e), o = getComputedStyle(t), r = e.steps[0].styles, i = e.steps[e.steps.length - 1].styles, s = [r, i];
  for (const l of s)
    for (const a of n)
      a in l || (l[a] = o[a]);
}
function Vn(e) {
  const t = [];
  for (const n of e.steps)
    for (const o in n.styles)
      t.indexOf(o) === -1 && t.push(o);
  return t;
}
function it(e) {
  const t = Array.prototype.slice.call(document.getElementsByClassName(e.elementId || e.id || ""));
  if (!t.length) {
    ot(e.elementId || e.id || "");
    return;
  }
  Array.from(t).forEach((n) => {
    rt(e, n), n.style.transition = "none", n.style.transitionDelay = "0", K(n.style, e.steps[0].styles), setTimeout(() => {
      n.style.transition = `all ${e.duration}s ${ye(e.easing)}`, e.delay && (n.style.transitionDelay = e.delay + "s"), K(n.style, e.steps[1].styles), setTimeout(() => {
        n.style.transition = "", n.style.transitionDelay = "";
      }, (e.delay || 0) * 1e3 + e.duration * 1e3 + 100);
    });
  });
}
function Wn(e) {
  const t = Array.prototype.slice.call(document.getElementsByClassName(e.elementId || e.id || ""));
  if (!t.length) {
    ot(e.elementId || e.id || "");
    return;
  }
  Array.from(t).forEach((n) => {
    rt(e, n);
    let o = !1, r = !1;
    function i() {
      !o && l(n) ? (o = !0, r = !0, setTimeout(() => {
        K(n.style, e.steps[1].styles), e.repeat || document.removeEventListener("scroll", s), setTimeout(() => {
          r = !1, e.repeat || (n.style.transition = "", n.style.transitionDelay = "");
        }, (e.duration + (e.delay || 0)) * 1e3 + 100);
      })) : e.repeat && o && !r && !l(n) && (o = !1, K(n.style, e.steps[0].styles));
    }
    const s = xn(i, 200, {
      leading: !1
    });
    function l(m) {
      const h = m.getBoundingClientRect(), d = window.innerHeight, S = (e.thresholdPercent || 0) / 100 * d;
      return h.bottom > S && h.top < d - S;
    }
    const a = e.steps[0].styles;
    function u() {
      K(n.style, a);
    }
    u(), setTimeout(() => {
      n.style.transition = `all ${e.duration}s ${ye(e.easing)}`, e.delay && (n.style.transitionDelay = e.delay + "s");
    }), document.addEventListener("scroll", s, {
      capture: !0,
      passive: !0
    }), i();
  });
}
const st = (e) => Object.entries(e).map(([n, o]) => {
  if (typeof o == "string")
    return `${ye(n)}: ${o};`;
}).filter(D), Nn = (e) => st(e).join(`
`), Ui = ({
  mediaQuery: e,
  className: t,
  styles: n
}) => {
  const o = `.${t} {
    ${Nn(n)}
  }`;
  return e ? `${e} {
      ${o}
    }` : o;
};
function On({
  style: e
}) {
  return e;
}
const Mi = ({
  block: e,
  context: t
}) => at(On({
  style: e.style || {},
  context: t,
  block: e
}));
function at(e) {
  switch (P) {
    case "svelte":
    case "vue":
    case "solid":
    case "angular":
      return st(e).join(" ");
    case "qwik":
    case "reactNative":
    case "react":
    case "rsc":
      return e;
  }
}
const Fn = ({
  block: e,
  registeredComponents: t
}) => {
  var r;
  const n = (r = e.component) == null ? void 0 : r.name;
  if (!n)
    return null;
  const o = t[n];
  if (o)
    return o;
  console.warn(`
      Could not find a registered component named "${n}". 
      If you registered it, is the file that registered it imported by the file that needs to render it?`);
}, Dn = ({
  block: e,
  context: t
}) => {
  const {
    repeat: n,
    ...o
  } = e;
  if (!(n != null && n.collection))
    return;
  const r = J({
    code: n.collection,
    localState: t.localState,
    rootState: t.rootState,
    rootSetState: t.rootSetState,
    context: t.context
  });
  if (!Array.isArray(r))
    return;
  const i = n.collection.split(".").pop(), s = n.itemName || (i ? i + "Item" : "item");
  return r.map((a, u) => ({
    context: {
      ...t,
      localState: {
        ...t.localState,
        $index: u,
        $item: a,
        [s]: a,
        [`$${s}Index`]: u
      }
    },
    block: o
  }));
}, Ln = (e, t) => {
  var n;
  return (n = e == null ? void 0 : e.shouldReceiveBuilderProps) != null && n.builderLinkComponent ? {
    builderLinkComponent: t
  } : {};
}, Un = (e, t) => {
  var n;
  return (n = e == null ? void 0 : e.shouldReceiveBuilderProps) != null && n.builderComponents ? {
    builderComponents: t
  } : {};
}, Mn = (e, t) => {
  var n;
  return (n = e == null ? void 0 : e.shouldReceiveBuilderProps) != null && n.builderBlock ? {
    builderBlock: t
  } : {};
}, Hn = (e, t) => {
  var n;
  return (n = e == null ? void 0 : e.shouldReceiveBuilderProps) != null && n.builderContext ? {
    builderContext: t
  } : {};
}, jn = () => Promise.resolve().then(() => oo).then((e) => e.default).catch((e) => {
  throw console.error(
    "Error while attempting to dynamically import component DynamicDiv at ../dynamic-div.vue",
    e
  ), e;
}), Kn = () => import("./block-styles-1TjUGG0M.js").then((e) => e.default).catch((e) => {
  throw console.error(
    "Error while attempting to dynamically import component BlockStyles at ./components/block-styles.vue",
    e
  ), e;
}), qn = () => import("./block-wrapper-mHstZCm3.js").then((e) => e.default).catch((e) => {
  throw console.error(
    "Error while attempting to dynamically import component BlockWrapper at ./components/block-wrapper.vue",
    e
  ), e;
}), zn = () => import("./component-ref-SiTniDkf.js").then((e) => e.default).catch((e) => {
  throw console.error(
    "Error while attempting to dynamically import component ComponentRef at ./components/component-ref/component-ref.vue",
    e
  ), e;
}), Gn = () => import("./repeated-block-WkFOmnw-.js").then((e) => e.default).catch((e) => {
  throw console.error(
    "Error while attempting to dynamically import component RepeatedBlock at ./components/repeated-block.vue",
    e
  ), e;
}), Jn = b({
  name: "block",
  components: {
    BlockStyles: H(Kn),
    RepeatedBlock: H(Gn),
    ComponentRef: H(zn),
    BlockWrapper: H(qn),
    DynamicDiv: H(jn)
  },
  props: ["block", "context", "registeredComponents", "linkComponent"],
  data() {
    return {
      _processedBlock: {
        value: null,
        update: !1
      }
    };
  },
  mounted() {
    const e = this.processedBlock.id, t = this.processedBlock.animations;
    t && e && An(
      t.map((n) => ({
        ...n,
        elementId: e
      }))
    );
  },
  updated() {
  },
  computed: {
    repeatItem() {
      return Dn({
        block: this.block,
        context: this.context
      });
    },
    processedBlock() {
      var t;
      return (t = this.block.repeat) != null && t.collection ? this.block : qt({
        block: this.block,
        localState: this.context.localState,
        rootState: this.context.rootState,
        rootSetState: this.context.rootSetState,
        context: this.context.context,
        shouldEvaluateBindings: !0
      });
    },
    blockComponent() {
      return Fn({
        block: this.processedBlock,
        registeredComponents: this.registeredComponents
      });
    },
    Tag() {
      var t;
      return this.block.tagName === "a" || ((t = this.processedBlock.properties) == null ? void 0 : t.href) || this.processedBlock.href ? this.linkComponent || "a" : this.block.tagName || "div";
    },
    canShowBlock() {
      var n, o;
      if ((n = this.block.repeat) != null && n.collection)
        return !!((o = this.repeatItem) != null && o.length);
      const e = "hide" in this.processedBlock ? this.processedBlock.hide : !1;
      return ("show" in this.processedBlock ? this.processedBlock.show : !0) && !e;
    },
    childrenWithoutParentComponent() {
      var t;
      return !((t = this.blockComponent) != null && t.component) && !this.repeatItem ? this.processedBlock.children ?? [] : [];
    },
    componentRefProps() {
      var e, t, n;
      return {
        blockChildren: this.processedBlock.children ?? [],
        componentRef: (e = this.blockComponent) == null ? void 0 : e.component,
        componentOptions: {
          ...Rt(this.processedBlock),
          ...Mn(this.blockComponent, this.processedBlock),
          ...Hn(this.blockComponent, this.context),
          ...Ln(this.blockComponent, this.linkComponent),
          ...Un(
            this.blockComponent,
            this.registeredComponents
          )
        },
        context: this.context,
        linkComponent: this.linkComponent,
        registeredComponents: this.registeredComponents,
        builderBlock: this.processedBlock,
        includeBlockProps: ((t = this.blockComponent) == null ? void 0 : t.noWrap) === !0,
        isInteractive: !((n = this.blockComponent) != null && n.isRSC && P === "rsc")
      };
    }
  }
});
function Yn(e, t, n, o, r, i) {
  var h;
  const s = k("BlockStyles"), l = k("ComponentRef"), a = k("Block", !0), u = k("BlockWrapper"), m = k("RepeatedBlock");
  return e.canShowBlock ? (c(), p(T, { key: 0 }, [
    R(s, {
      block: e.processedBlock,
      context: e.context
    }, null, 8, ["block", "context"]),
    (h = e.blockComponent) != null && h.noWrap ? (c(), p(T, { key: 1 }, [
      e.repeatItem ? (c(!0), p(T, { key: 1 }, V(e.repeatItem, (d, f) => (c(), y(m, {
        key: f,
        repeatContext: d.context,
        block: d.block,
        registeredComponents: e.registeredComponents,
        linkComponent: e.linkComponent
      }, null, 8, ["repeatContext", "block", "registeredComponents", "linkComponent"]))), 128)) : (c(), y(l, {
        key: 0,
        componentRef: e.componentRefProps.componentRef,
        componentOptions: e.componentRefProps.componentOptions,
        blockChildren: e.componentRefProps.blockChildren,
        context: e.componentRefProps.context,
        registeredComponents: e.componentRefProps.registeredComponents,
        linkComponent: e.componentRefProps.linkComponent,
        builderBlock: e.componentRefProps.builderBlock,
        includeBlockProps: e.componentRefProps.includeBlockProps,
        isInteractive: e.componentRefProps.isInteractive
      }, null, 8, ["componentRef", "componentOptions", "blockChildren", "context", "registeredComponents", "linkComponent", "builderBlock", "includeBlockProps", "isInteractive"]))
    ], 64)) : (c(), p(T, { key: 0 }, [
      e.repeatItem ? (c(!0), p(T, { key: 1 }, V(e.repeatItem, (d, f) => (c(), y(m, {
        key: f,
        repeatContext: d.context,
        block: d.block,
        registeredComponents: e.registeredComponents,
        linkComponent: e.linkComponent
      }, null, 8, ["repeatContext", "block", "registeredComponents", "linkComponent"]))), 128)) : (c(), y(u, {
        key: 0,
        Wrapper: e.Tag,
        block: e.processedBlock,
        context: e.context
      }, {
        default: N(() => [
          R(l, {
            componentRef: e.componentRefProps.componentRef,
            componentOptions: e.componentRefProps.componentOptions,
            blockChildren: e.componentRefProps.blockChildren,
            context: e.componentRefProps.context,
            registeredComponents: e.componentRefProps.registeredComponents,
            linkComponent: e.componentRefProps.linkComponent,
            builderBlock: e.componentRefProps.builderBlock,
            includeBlockProps: e.componentRefProps.includeBlockProps,
            isInteractive: e.componentRefProps.isInteractive
          }, null, 8, ["componentRef", "componentOptions", "blockChildren", "context", "registeredComponents", "linkComponent", "builderBlock", "includeBlockProps", "isInteractive"]),
          (c(!0), p(T, null, V(e.childrenWithoutParentComponent, (d, f) => (c(), y(a, {
            key: d.id,
            block: d,
            registeredComponents: e.registeredComponents,
            linkComponent: e.linkComponent,
            context: e.context
          }, null, 8, ["block", "registeredComponents", "linkComponent", "context"]))), 128))
        ]),
        _: 1
      }, 8, ["Wrapper", "block", "context"]))
    ], 64))
  ], 64)) : v("", !0);
}
const ke = /* @__PURE__ */ g(Jn, [["render", Yn]]), Hi = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ke
}, Symbol.toStringTag, { value: "Module" })), Xn = b({
  name: "builder-blocks-wrapper",
  props: [
    "blocks",
    "classNameProp",
    "path",
    "parent",
    "styleProp",
    "BlocksWrapperProps",
    "BlocksWrapper"
  ],
  mounted() {
  },
  computed: {
    className() {
      var e;
      return [
        "builder-blocks",
        (e = this.blocks) != null && e.length ? "" : "no-blocks",
        this.classNameProp
      ].filter(Boolean).join(" ");
    },
    dataPath() {
      if (!this.path)
        return;
      const e = "component.options.";
      return this.path.startsWith(e) ? this.path : `${e}${this.path || ""}`;
    }
  },
  methods: {
    onClick() {
      var e, t;
      B() && !((e = this.blocks) != null && e.length) && ((t = window.parent) == null || t.postMessage(
        {
          type: "builder.clickEmptyBlocks",
          data: {
            parentElementId: this.parent,
            dataPath: this.dataPath
          }
        },
        "*"
      ));
    },
    onMouseEnter() {
      var e, t;
      B() && !((e = this.blocks) != null && e.length) && ((t = window.parent) == null || t.postMessage(
        {
          type: "builder.hoverEmptyBlocks",
          data: {
            parentElementId: this.parent,
            dataPath: this.dataPath
          }
        },
        "*"
      ));
    }
  }
});
function Qn(e, t, n, o, r, i) {
  return c(), y(j(e.BlocksWrapper), C({
    ref: "blocksWrapperRef",
    class: e.className + " component-1k2igrjdg3x",
    "builder-path": e.dataPath,
    "builder-parent-id": e.parent,
    style: e.styleProp,
    onClick: (s) => e.onClick(),
    onMouseEnter: (s) => e.onMouseEnter(),
    onKeyPress: (s) => e.onClick()
  }, { ...e.BlocksWrapperProps }), {
    default: N(() => [
      A(e.$slots, "default", {}, void 0, !0)
    ]),
    _: 3
  }, 16, ["class", "builder-path", "builder-parent-id", "style", "onClick", "onMouseEnter", "onKeyPress"]);
}
const Zn = /* @__PURE__ */ g(Xn, [["render", Qn], ["__scopeId", "data-v-ba2bc5c0"]]), _n = b({
  name: "builder-blocks",
  components: { BlocksWrapper: Zn, Block: ke },
  props: [
    "blocks",
    "parent",
    "path",
    "styleProp",
    "className",
    "context",
    "linkComponent",
    "registeredComponents"
  ],
  inject: {
    builderContext: le.key,
    componentsContext: Ve.key
  }
});
function eo(e, t, n, o, r, i) {
  var a, u, m, h;
  const s = k("Block"), l = k("BlocksWrapper");
  return c(), y(l, {
    blocks: e.blocks,
    parent: e.parent,
    path: e.path,
    styleProp: e.styleProp,
    classNameProp: e.className,
    BlocksWrapper: ((a = e.context) == null ? void 0 : a.BlocksWrapper) || ((u = e.builderContext) == null ? void 0 : u.BlocksWrapper),
    BlocksWrapperProps: ((m = e.context) == null ? void 0 : m.BlocksWrapperProps) || ((h = e.builderContext) == null ? void 0 : h.BlocksWrapperProps)
  }, {
    default: N(() => [
      e.blocks ? (c(!0), p(T, { key: 0 }, V(e.blocks, (d, f) => {
        var S;
        return c(), y(s, {
          key: d.id,
          block: d,
          linkComponent: e.linkComponent,
          context: e.context || e.builderContext,
          registeredComponents: e.registeredComponents || ((S = e.componentsContext) == null ? void 0 : S.registeredComponents)
        }, null, 8, ["block", "linkComponent", "context", "registeredComponents"]);
      }), 128)) : v("", !0)
    ]),
    _: 1
  }, 8, ["blocks", "parent", "path", "styleProp", "classNameProp", "BlocksWrapper", "BlocksWrapperProps"]);
}
const U = /* @__PURE__ */ g(_n, [["render", eo]]), to = b({
  name: "dynamic-div",
  props: []
});
function no(e, t, n, o, r, i) {
  return c(), p("div", null, [
    A(e.$slots, "default")
  ]);
}
const Y = /* @__PURE__ */ g(to, [["render", no]]), oo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Y
}, Symbol.toStringTag, { value: "Module" })), ve = b({
  render() {
    return Ae("style", {
      innerHTML: this.styles,
      "data-id": this.id,
      nonce: this.nonce
    });
  },
  name: "inlined-styles",
  props: ["styles", "id", "nonce"]
}), lt = {
  small: {
    min: 320,
    default: 321,
    max: 640
  },
  medium: {
    min: 641,
    default: 642,
    max: 991
  },
  large: {
    min: 990,
    default: 991,
    max: 1200
  }
}, ji = (e, t = lt) => `@media (max-width: ${t[e].max}px)`, ro = ({
  small: e,
  medium: t
}) => {
  const n = me(lt);
  if (!e || !t)
    return n;
  const o = Math.floor(e / 2);
  n.small = {
    max: e,
    min: o,
    default: o + 1
  };
  const r = n.small.max + 1;
  n.medium = {
    max: t,
    min: r,
    default: r + 1
  };
  const i = n.medium.max + 1;
  return n.large = {
    max: 2e3,
    // TODO: decide upper limit
    min: i,
    default: i + 1
  }, n;
}, io = (e) => `builder-columns ${e}-breakpoints`, so = b({
  name: "builder-columns",
  components: {
    InlinedStyles: ve,
    DynamicRenderer: pe,
    Blocks: U,
    DynamicDiv: Y
  },
  props: [
    "space",
    "columns",
    "stackColumnsAt",
    "builderLinkComponent",
    "reverseColumnsWhenStacked",
    "builderContext",
    "builderBlock",
    "builderComponents"
  ],
  data() {
    return { TARGET: P, getColumnsClass: io };
  },
  computed: {
    gutterSize() {
      return typeof this.space == "number" ? this.space || 0 : 20;
    },
    cols() {
      return this.columns || [];
    },
    stackAt() {
      return this.stackColumnsAt || "tablet";
    },
    flexDir() {
      return this.stackColumnsAt === "never" ? "row" : this.reverseColumnsWhenStacked ? "column-reverse" : "column";
    }
  },
  methods: {
    getTagName(e) {
      return e.link ? this.builderLinkComponent || "a" : "div";
    },
    getWidth(e) {
      var t;
      return ((t = this.cols[e]) == null ? void 0 : t.width) || 100 / this.cols.length;
    },
    getColumnCssWidth(e) {
      const t = this.getWidth(e), n = this.gutterSize * (this.cols.length - 1) * (t / 100);
      return `calc(${t}% - ${n}px)`;
    },
    getTabletStyle({
      stackedStyle: e,
      desktopStyle: t
    }) {
      return this.stackAt === "tablet" ? e : t;
    },
    getMobileStyle({
      stackedStyle: e,
      desktopStyle: t
    }) {
      return this.stackAt === "never" ? t : e;
    },
    columnsCssVars() {
      return {
        "--flex-dir": this.flexDir,
        "--flex-dir-tablet": this.getTabletStyle({
          stackedStyle: this.flexDir,
          desktopStyle: "row"
        })
      };
    },
    columnCssVars(e) {
      const t = e === 0 ? 0 : this.gutterSize, n = this.getColumnCssWidth(e), o = `${t}px`, r = "100%", i = 0;
      return {
        ...{
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch"
        },
        width: n,
        ["margin-left"]: o,
        "--column-width-mobile": this.getMobileStyle({
          stackedStyle: r,
          desktopStyle: n
        }),
        "--column-margin-left-mobile": this.getMobileStyle({
          stackedStyle: i,
          desktopStyle: o
        }),
        "--column-width-tablet": this.getTabletStyle({
          stackedStyle: r,
          desktopStyle: n
        }),
        "--column-margin-left-tablet": this.getTabletStyle({
          stackedStyle: i,
          desktopStyle: o
        })
      };
    },
    getWidthForBreakpointSize(e) {
      var n, o;
      return ro(
        ((o = (n = this.builderContext.content) == null ? void 0 : n.meta) == null ? void 0 : o.breakpoints) || {}
      )[e].max;
    },
    columnsStyles() {
      const e = `.${this.builderBlock.id}-breakpoints > .builder-column`;
      return `
        @media (max-width: ${this.getWidthForBreakpointSize("medium")}px) {
          .${this.builderBlock.id}-breakpoints {
            flex-direction: var(--flex-dir-tablet);
            align-items: stretch;
          }

          ${e} {
            width: var(--column-width-tablet) !important;
            margin-left: var(--column-margin-left-tablet) !important;
          }
        }

        @media (max-width: ${this.getWidthForBreakpointSize("small")}px) {
          .${this.builderBlock.id}-breakpoints {
            flex-direction: var(--flex-dir);
            align-items: stretch;
          }

          ${e} {
            width: var(--column-width-mobile) !important;
            margin-left: var(--column-margin-left-mobile) !important;
          }
        },
      `;
    },
    getAttributes(e, t) {
      return {
        ...e.link ? {
          href: e.link
        } : {},
        [_()]: "builder-column",
        style: at(this.columnCssVars(t))
      };
    }
  }
});
function ao(e, t, n, o, r, i) {
  var u;
  const s = k("InlinedStyles"), l = k("Blocks"), a = k("DynamicRenderer");
  return c(), p("div", C({
    class: e.getColumnsClass((u = e.builderBlock) == null ? void 0 : u.id) + " div-4wbls88y960",
    style: e.columnsCssVars()
  }, {}), [
    e.TARGET !== "reactNative" ? (c(), y(s, {
      key: 0,
      id: "builderio-columns",
      styles: e.columnsStyles(),
      nonce: e.builderContext.nonce
    }, null, 8, ["styles", "nonce"])) : v("", !0),
    (c(!0), p(T, null, V(e.columns, (m, h) => (c(), y(a, {
      key: h,
      TagName: e.getTagName(m),
      actionAttributes: {},
      attributes: e.getAttributes(m, h)
    }, {
      default: N(() => [
        R(l, {
          path: `columns.${h}.blocks`,
          parent: e.builderBlock.id,
          styleProp: {
            flexGrow: "1"
          },
          context: e.builderContext,
          registeredComponents: e.builderComponents,
          linkComponent: e.builderLinkComponent,
          blocks: m.blocks
        }, null, 8, ["path", "parent", "context", "registeredComponents", "linkComponent", "blocks"])
      ]),
      _: 2
    }, 1032, ["TagName", "attributes"]))), 128))
  ], 16);
}
const lo = /* @__PURE__ */ g(so, [["render", ao], ["__scopeId", "data-v-3354f136"]]), co = b({
  name: "builder-fragment-component",
  props: []
});
function uo(e, t, n, o, r, i) {
  return c(), p("span", null, [
    A(e.$slots, "default")
  ]);
}
const po = /* @__PURE__ */ g(co, [["render", uo]]);
function Ee(e) {
  return e.replace(/http(s)?:/, "");
}
function mo(e = "", t, n) {
  const o = new RegExp("([?&])" + t + "=.*?(&|$)", "i"), r = e.indexOf("?") !== -1 ? "&" : "?";
  return e.match(o) ? e.replace(o, "$1" + t + "=" + encodeURIComponent(n) + "$2") : e + r + t + "=" + encodeURIComponent(n);
}
function ho(e, t) {
  if (!e || !(e != null && e.match(/cdn\.shopify\.com/)) || !t)
    return e;
  if (t === "master")
    return Ee(e);
  const n = e.match(/(_\d+x(\d+)?)?(\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?)/i);
  if (n) {
    const o = e.split(n[0]), r = n[3], i = t.match("x") ? t : `${t}x`;
    return Ee(`${o[0]}_${i}${r}`);
  }
  return null;
}
function oe(e) {
  if (!e)
    return e;
  const t = [100, 200, 400, 800, 1200, 1600, 2e3];
  if (e.match(/builder\.io/)) {
    let n = e;
    const o = Number(e.split("?width=")[1]);
    return isNaN(o) || (n = `${n} ${o}w`), t.filter((r) => r !== o).map((r) => `${mo(e, "width", r)} ${r}w`).concat([n]).join(", ");
  }
  return e.match(/cdn\.shopify\.com/) ? t.map((n) => [ho(e, `${n}x${n}`), n]).filter(([n]) => !!n).map(([n, o]) => `${n} ${o}w`).concat([e]).join(", ") : e;
}
const fo = b({
  name: "builder-image",
  props: [
    "image",
    "src",
    "srcset",
    "noWebp",
    "aspectRatio",
    "highPriority",
    "altText",
    "backgroundPosition",
    "backgroundSize",
    "className",
    "sizes",
    "builderBlock",
    "fitContent"
  ],
  mounted() {
  },
  computed: {
    srcSetToUse() {
      var n;
      const t = this.image || this.src;
      if (!t || // We can auto add srcset for cdn.builder.io and shopify
      // images, otherwise you can supply this prop manually
      !(t.match(/builder\.io/) || t.match(/cdn\.shopify\.com/)))
        return this.srcset;
      if (!this.noWebp) {
        if (this.srcset && ((n = this.image) != null && n.includes("builder.io/api/v1/image"))) {
          if (!this.srcset.includes(this.image.split("?")[0]))
            return console.debug("Removed given srcset"), oe(t);
        } else if (this.image && !this.srcset)
          return oe(t);
        return oe(t);
      }
    },
    webpSrcSet() {
      var e;
      return (e = this.srcSetToUse) != null && e.match(/builder\.io/) && !this.noWebp ? this.srcSetToUse.replace(/\?/g, "?format=webp&") : "";
    },
    aspectRatioCss() {
      const e = {
        position: "absolute",
        height: "100%",
        width: "100%",
        left: "0px",
        top: "0px"
      };
      return this.aspectRatio ? e : void 0;
    }
  }
}), bo = ["srcset"], go = ["loading", "fetchpriority", "alt", "role", "src", "srcset", "sizes"], yo = {
  key: 2,
  class: "div-29wpyomtntv-2"
};
function ko(e, t, n, o, r, i) {
  var s, l, a, u, m, h;
  return c(), p(T, null, [
    q("picture", null, [
      e.webpSrcSet ? (c(), p("source", {
        key: 0,
        type: "image/webp",
        srcset: e.webpSrcSet
      }, null, 8, bo)) : v("", !0),
      q("img", {
        loading: e.highPriority ? "eager" : "lazy",
        fetchpriority: e.highPriority ? "high" : "auto",
        alt: e.altText,
        role: e.altText ? void 0 : "presentation",
        style: F({
          objectPosition: e.backgroundPosition || "center",
          objectFit: e.backgroundSize || "cover",
          ...e.aspectRatioCss
        }),
        class: z(
          "builder-image" + (e.className ? " " + e.className : "") + " img-29wpyomtntv"
        ),
        src: e.image,
        srcset: e.srcSetToUse,
        sizes: e.sizes
      }, null, 14, go)
    ]),
    e.aspectRatio && !((l = (s = e.builderBlock) == null ? void 0 : s.children) != null && l.length && e.fitContent) ? (c(), p("div", {
      key: 0,
      class: "builder-image-sizer div-29wpyomtntv",
      style: F({
        paddingTop: e.aspectRatio * 100 + "%"
      })
    }, null, 4)) : v("", !0),
    (u = (a = e.builderBlock) == null ? void 0 : a.children) != null && u.length && e.fitContent ? A(e.$slots, "default", { key: 1 }, void 0, !0) : v("", !0),
    !e.fitContent && ((h = (m = e.builderBlock) == null ? void 0 : m.children) != null && h.length) ? (c(), p("div", yo, [
      A(e.$slots, "default", {}, void 0, !0)
    ])) : v("", !0)
  ], 64);
}
const vo = /* @__PURE__ */ g(fo, [["render", ko], ["__scopeId", "data-v-77f8a6c4"]]), So = b({
  name: "builder-section-component",
  props: ["attributes", "maxWidth"],
  data() {
    return { filterAttrs: W };
  }
});
function Co(e, t, n, o, r, i) {
  return c(), p("section", C({
    style: {
      width: "100%",
      alignSelf: "stretch",
      flexGrow: 1,
      boxSizing: "border-box",
      maxWidth: e.maxWidth || 1200,
      display: "flex",
      flexDirection: "column",
      alignItems: "stretch",
      marginLeft: "auto",
      marginRight: "auto"
    }
  }, e.filterAttrs(e.attributes, "v-on:", !1), x(e.filterAttrs(e.attributes, "v-on:", !0), !0)), [
    A(e.$slots, "default")
  ], 16);
}
const wo = /* @__PURE__ */ g(So, [["render", Co]]), re = {
  "@type": "@builder.io/sdk:Element",
  layerName: "Accordion item title",
  responsiveStyles: {
    large: {
      marginTop: "10px",
      position: "relative",
      display: "flex",
      alignItems: "stretch",
      flexDirection: "column",
      paddingBottom: "10px"
    }
  },
  children: [{
    "@type": "@builder.io/sdk:Element",
    responsiveStyles: {
      large: {
        textAlign: "left",
        display: "flex",
        flexDirection: "column"
      }
    },
    component: {
      name: "Text",
      options: {
        text: "I am an accordion title. Click me!"
      }
    }
  }]
}, ie = {
  "@type": "@builder.io/sdk:Element",
  layerName: "Accordion item detail",
  responsiveStyles: {
    large: {
      position: "relative",
      display: "flex",
      alignItems: "stretch",
      flexDirection: "column",
      marginTop: "10px",
      paddingBottom: "10px"
    }
  },
  children: [{
    "@type": "@builder.io/sdk:Element",
    responsiveStyles: {
      large: {
        paddingTop: "50px",
        textAlign: "left",
        display: "flex",
        flexDirection: "column",
        paddingBottom: "50px"
      }
    },
    component: {
      name: "Text",
      options: {
        text: "I am an accordion detail, hello!"
      }
    }
  }]
}, To = {
  name: "Builder:Accordion",
  canHaveChildren: !0,
  image: "https://cdn.builder.io/api/v1/image/assets%2FagZ9n5CUKRfbL9t6CaJOyVSK4Es2%2Ffab6c1fd3fe542408cbdec078bca7f35",
  defaultStyles: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch"
  },
  inputs: [{
    name: "items",
    type: "list",
    broadcast: !0,
    subFields: [{
      name: "title",
      type: "uiBlocks",
      hideFromUI: !0,
      defaultValue: [re]
    }, {
      name: "detail",
      type: "uiBlocks",
      hideFromUI: !0,
      defaultValue: [ie]
    }],
    defaultValue: [{
      title: [re],
      detail: [ie]
    }, {
      title: [re],
      detail: [ie]
    }],
    showIf: (e) => !e.get("useChildrenForItems")
  }, {
    name: "oneAtATime",
    helperText: "Only allow opening one at a time (collapse all others when new item openned)",
    type: "boolean",
    defaultValue: !1
  }, {
    name: "grid",
    helperText: "Display as a grid",
    type: "boolean",
    defaultValue: !1
  }, {
    name: "gridRowWidth",
    helperText: "Display as a grid",
    type: "string",
    showIf: (e) => e.get("grid"),
    defaultValue: "25%"
  }, {
    name: "useChildrenForItems",
    type: "boolean",
    helperText: "Use child elements for each slide, instead of the array. Useful for dynamically repeating items",
    advanced: !0,
    defaultValue: !1,
    onChange: (e) => {
      e.get("useChildrenForItems") === !0 && e.set("items", []);
    }
  }],
  shouldReceiveBuilderProps: {
    builderBlock: !0,
    builderContext: !0,
    builderComponents: !0,
    builderLinkComponent: !0
  }
}, Io = (e) => e.toString(), $o = b({
  name: "builder-accordion",
  components: { Blocks: U },
  props: [
    "grid",
    "oneAtATime",
    "items",
    "gridRowWidth",
    "builderBlock",
    "builderContext",
    "builderComponents",
    "builderLinkComponent"
  ],
  data() {
    return { open: [], convertOrderNumberToString: Io };
  },
  computed: {
    onlyOneAtATime() {
      return !!(this.grid || this.oneAtATime);
    },
    accordionStyles() {
      return {
        display: "flex",
        alignItems: "stretch",
        flexDirection: "column",
        ...this.grid && {
          flexDirection: "row",
          alignItems: "flex-start",
          flexWrap: "wrap"
        }
      };
    },
    accordionTitleStyles() {
      const t = {
        ...{
          display: "flex",
          flexDirection: "column"
        },
        alignItems: "stretch",
        cursor: "pointer"
      };
      return Object.fromEntries(
        Object.entries(t).filter(([n, o]) => o !== void 0)
      );
    },
    openGridItemOrder() {
      let e = null;
      if (this.grid && this.open.length && document) {
        const n = this.open[0];
        let r = document.querySelector(
          `.builder-accordion-title[data-index="${n}"]`
        );
        if (e = n, r) {
          let i = r.getBoundingClientRect();
          for (; r = r && r.nextElementSibling; )
            if (r) {
              if (r.classList.contains("builder-accordion-detail"))
                continue;
              const s = r.getBoundingClientRect();
              if (s.left > i.left) {
                const l = parseInt(
                  r.getAttribute("data-index") || "",
                  10
                );
                isNaN(l) || (i = s, e = l);
              } else
                break;
            }
        }
      }
      return typeof e == "number" && (e = e + 1), e;
    },
    accordionDetailStyles() {
      const e = {
        order: typeof this.openGridItemOrder == "number" ? this.openGridItemOrder : void 0,
        ...this.grid && {
          width: "100%"
        }
      };
      return Object.fromEntries(
        Object.entries(e).filter(([t, n]) => n !== void 0)
      );
    }
  },
  methods: {
    getAccordionTitleClassName(e) {
      return `builder-accordion-title builder-accordion-title-${this.open.includes(e) ? "open" : "closed"}`;
    },
    getAccordionDetailClassName(e) {
      return `builder-accordion-detail builder-accordion-detail-${this.open.includes(e) ? "open" : "closed"}`;
    },
    onClick(e) {
      this.open.includes(e) ? this.open = this.onlyOneAtATime ? [] : this.open.filter((t) => t !== e) : this.open = this.onlyOneAtATime ? [e] : this.open.concat(e);
    }
  }
}), Ro = ["data-index", "onClick"];
function Eo(e, t, n, o, r, i) {
  const s = k("Blocks");
  return c(), p("div", {
    class: "builder-accordion",
    style: F(e.accordionStyles)
  }, [
    (c(!0), p(T, null, V(e.items, (l, a) => (c(), p(T, { key: a }, [
      q("div", {
        class: z(e.getAccordionTitleClassName(a)),
        style: F({
          ...e.accordionTitleStyles,
          ...e.grid && {
            width: e.gridRowWidth,
            order: e.openGridItemOrder !== null ? e.convertOrderNumberToString(a) : e.convertOrderNumberToString(a + 1)
          }
        }),
        "data-index": a,
        onClick: (u) => e.onClick(a)
      }, [
        R(s, {
          blocks: l.title,
          path: `items.${a}.title`,
          parent: e.builderBlock.id,
          context: e.builderContext,
          registeredComponents: e.builderComponents,
          linkComponent: e.builderLinkComponent
        }, null, 8, ["blocks", "path", "parent", "context", "registeredComponents", "linkComponent"])
      ], 14, Ro),
      e.open.includes(a) ? (c(), p("div", {
        key: 0,
        class: z(e.getAccordionDetailClassName(a)),
        style: F(e.accordionDetailStyles)
      }, [
        R(s, {
          blocks: l.detail,
          path: `items.${a}.detail`,
          parent: e.builderBlock.id,
          context: e.builderContext,
          registeredComponents: e.builderComponents,
          linkComponent: e.builderLinkComponent
        }, null, 8, ["blocks", "path", "parent", "context", "registeredComponents", "linkComponent"])
      ], 6)) : v("", !0)
    ], 64))), 128))
  ], 4);
}
const Po = /* @__PURE__ */ g($o, [["render", Eo]]), Bo = {
  name: "Core:Button",
  image: "https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2F81a15681c3e74df09677dfc57a615b13",
  defaultStyles: {
    // TODO: make min width more intuitive and set one
    appearance: "none",
    paddingTop: "15px",
    paddingBottom: "15px",
    paddingLeft: "25px",
    paddingRight: "25px",
    backgroundColor: "#000000",
    color: "white",
    borderRadius: "4px",
    textAlign: "center",
    cursor: "pointer"
  },
  inputs: [{
    name: "text",
    type: "text",
    defaultValue: "Click me!",
    bubble: !0
  }, {
    name: "link",
    type: "url",
    bubble: !0
  }, {
    name: "openLinkInNewTab",
    type: "boolean",
    defaultValue: !1,
    friendlyName: "Open link in new tab"
  }],
  static: !0,
  noWrap: !0,
  shouldReceiveBuilderProps: {
    builderLinkComponent: !0
  }
}, xo = {
  // TODO: ways to statically preprocess JSON for references, functions, etc
  name: "Columns",
  isRSC: !0,
  inputs: [{
    name: "columns",
    type: "array",
    broadcast: !0,
    subFields: [{
      name: "blocks",
      type: "array",
      hideFromUI: !0,
      defaultValue: [{
        "@type": "@builder.io/sdk:Element",
        responsiveStyles: {
          large: {
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            flexShrink: "0",
            position: "relative",
            marginTop: "30px",
            textAlign: "center",
            lineHeight: "normal",
            height: "auto",
            minHeight: "20px",
            minWidth: "20px",
            overflow: "hidden"
          }
        },
        component: {
          name: "Image",
          options: {
            image: "https://builder.io/api/v1/image/assets%2Fpwgjf0RoYWbdnJSbpBAjXNRMe9F2%2Ffb27a7c790324294af8be1c35fe30f4d",
            backgroundPosition: "center",
            backgroundSize: "cover",
            aspectRatio: 0.7004048582995948
          }
        }
      }, {
        "@type": "@builder.io/sdk:Element",
        responsiveStyles: {
          large: {
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            flexShrink: "0",
            position: "relative",
            marginTop: "30px",
            textAlign: "center",
            lineHeight: "normal",
            height: "auto"
          }
        },
        component: {
          name: "Text",
          options: {
            text: "<p>Enter some text...</p>"
          }
        }
      }]
    }, {
      name: "width",
      type: "number",
      hideFromUI: !0,
      helperText: "Width %, e.g. set to 50 to fill half of the space"
    }, {
      name: "link",
      type: "url",
      helperText: "Optionally set a url that clicking this column will link to"
    }],
    defaultValue: [{
      blocks: [{
        "@type": "@builder.io/sdk:Element",
        responsiveStyles: {
          large: {
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            flexShrink: "0",
            position: "relative",
            marginTop: "30px",
            textAlign: "center",
            lineHeight: "normal",
            height: "auto",
            minHeight: "20px",
            minWidth: "20px",
            overflow: "hidden"
          }
        },
        component: {
          name: "Image",
          options: {
            image: "https://builder.io/api/v1/image/assets%2Fpwgjf0RoYWbdnJSbpBAjXNRMe9F2%2Ffb27a7c790324294af8be1c35fe30f4d",
            backgroundPosition: "center",
            backgroundSize: "cover",
            aspectRatio: 0.7004048582995948
          }
        }
      }, {
        "@type": "@builder.io/sdk:Element",
        responsiveStyles: {
          large: {
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            flexShrink: "0",
            position: "relative",
            marginTop: "30px",
            textAlign: "center",
            lineHeight: "normal",
            height: "auto"
          }
        },
        component: {
          name: "Text",
          options: {
            text: "<p>Enter some text...</p>"
          }
        }
      }]
    }, {
      blocks: [{
        "@type": "@builder.io/sdk:Element",
        responsiveStyles: {
          large: {
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            flexShrink: "0",
            position: "relative",
            marginTop: "30px",
            textAlign: "center",
            lineHeight: "normal",
            height: "auto",
            minHeight: "20px",
            minWidth: "20px",
            overflow: "hidden"
          }
        },
        component: {
          name: "Image",
          options: {
            image: "https://builder.io/api/v1/image/assets%2Fpwgjf0RoYWbdnJSbpBAjXNRMe9F2%2Ffb27a7c790324294af8be1c35fe30f4d",
            backgroundPosition: "center",
            backgroundSize: "cover",
            aspectRatio: 0.7004048582995948
          }
        }
      }, {
        "@type": "@builder.io/sdk:Element",
        responsiveStyles: {
          large: {
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            flexShrink: "0",
            position: "relative",
            marginTop: "30px",
            textAlign: "center",
            lineHeight: "normal",
            height: "auto"
          }
        },
        component: {
          name: "Text",
          options: {
            text: "<p>Enter some text...</p>"
          }
        }
      }]
    }],
    onChange: (e) => {
      function t() {
        n.forEach((o) => {
          o.delete("width");
        });
      }
      const n = e.get("columns");
      Array.isArray(n) && n.find((r) => r.get("width")) && (n.find((i) => !i.get("width")) || n.reduce((l, a) => l + a.get("width"), 0) !== 100) && t();
    }
  }, {
    name: "space",
    type: "number",
    defaultValue: 20,
    helperText: "Size of gap between columns",
    advanced: !0
  }, {
    name: "stackColumnsAt",
    type: "string",
    defaultValue: "tablet",
    helperText: "Convert horizontal columns to vertical at what device size",
    enum: ["tablet", "mobile", "never"],
    advanced: !0
  }, {
    name: "reverseColumnsWhenStacked",
    type: "boolean",
    defaultValue: !1,
    helperText: "When stacking columns for mobile devices, reverse the ordering",
    advanced: !0
  }],
  shouldReceiveBuilderProps: {
    builderBlock: !0,
    builderContext: !0,
    builderComponents: !0,
    builderLinkComponent: !0
  }
}, Ao = {
  name: "Fragment",
  static: !0,
  hidden: !0,
  canHaveChildren: !0,
  noWrap: !0
}, Vo = {
  name: "Image",
  static: !0,
  image: "https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/images%2Fbaseline-insert_photo-24px.svg?alt=media&token=4e5d0ef4-f5e8-4e57-b3a9-38d63a9b9dc4",
  defaultStyles: {
    position: "relative",
    minHeight: "20px",
    minWidth: "20px",
    overflow: "hidden"
  },
  canHaveChildren: !0,
  inputs: [{
    name: "image",
    type: "file",
    bubble: !0,
    allowedFileTypes: ["jpeg", "jpg", "png", "svg", "webp"],
    required: !0,
    defaultValue: "https://cdn.builder.io/api/v1/image/assets%2FYJIGb4i01jvw0SRdL5Bt%2F72c80f114dc149019051b6852a9e3b7a",
    onChange: (e) => {
      e.delete("srcset"), e.delete("noWebp");
      function n(s, l = 6e4) {
        return new Promise((a, u) => {
          const m = document.createElement("img");
          let h = !1;
          m.onload = () => {
            h = !0, a(m);
          }, m.addEventListener("error", (d) => {
            console.warn("Image load failed", d.error), u(d.error);
          }), m.src = s, setTimeout(() => {
            h || u(new Error("Image load timed out"));
          }, l);
        });
      }
      function o(s) {
        return Math.round(s * 1e3) / 1e3;
      }
      const r = e.get("image"), i = e.get("aspectRatio");
      if (fetch(r).then((s) => s.blob()).then((s) => {
        s.type.includes("svg") && e.set("noWebp", !0);
      }), r && (!i || i === 0.7041))
        return n(r).then((s) => {
          const l = e.get("aspectRatio");
          e.get("image") === r && (!l || l === 0.7041) && s.width && s.height && (e.set("aspectRatio", o(s.height / s.width)), e.set("height", s.height), e.set("width", s.width));
        });
    }
  }, {
    name: "backgroundSize",
    type: "text",
    defaultValue: "cover",
    enum: [{
      label: "contain",
      value: "contain",
      helperText: "The image should never get cropped"
    }, {
      label: "cover",
      value: "cover",
      helperText: "The image should fill it's box, cropping when needed"
    }]
  }, {
    name: "backgroundPosition",
    type: "text",
    defaultValue: "center",
    enum: ["center", "top", "left", "right", "bottom", "top left", "top right", "bottom left", "bottom right"]
  }, {
    name: "altText",
    type: "string",
    helperText: "Text to display when the user has images off"
  }, {
    name: "height",
    type: "number",
    hideFromUI: !0
  }, {
    name: "width",
    type: "number",
    hideFromUI: !0
  }, {
    name: "sizes",
    type: "string",
    hideFromUI: !0
  }, {
    name: "srcset",
    type: "string",
    hideFromUI: !0
  }, {
    name: "lazy",
    type: "boolean",
    defaultValue: !0,
    hideFromUI: !0
  }, {
    name: "fitContent",
    type: "boolean",
    helperText: "When child blocks are provided, fit to them instead of using the image's aspect ratio",
    defaultValue: !0
  }, {
    name: "highPriority",
    type: "boolean",
    advanced: !0,
    helperText: "Mark this image as high priority compared to other images on the page. This prevents lazy loading of the image and tells the browser to load this image before others on the page."
  }, {
    name: "aspectRatio",
    type: "number",
    helperText: "This is the ratio of height/width, e.g. set to 1.5 for a 300px wide and 200px tall photo. Set to 0 to not force the image to maintain it's aspect ratio",
    advanced: !0,
    defaultValue: 0.7041
  }],
  shouldReceiveBuilderProps: {
    builderBlock: !0
  }
}, Wo = {
  name: "Core:Section",
  static: !0,
  image: "https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2F682efef23ace49afac61748dd305c70a",
  inputs: [{
    name: "maxWidth",
    type: "number",
    defaultValue: 1200
  }, {
    name: "lazyLoad",
    type: "boolean",
    defaultValue: !1,
    advanced: !0,
    description: "Only render this section when in view"
  }],
  defaultStyles: {
    paddingLeft: "20px",
    paddingRight: "20px",
    paddingTop: "50px",
    paddingBottom: "50px",
    marginTop: "0px",
    width: "100vw",
    marginLeft: "calc(50% - 50vw)"
  },
  canHaveChildren: !0,
  defaultChildren: [{
    "@type": "@builder.io/sdk:Element",
    responsiveStyles: {
      large: {
        textAlign: "center"
      }
    },
    component: {
      name: "Text",
      options: {
        text: "<p><b>I am a section! My content keeps from getting too wide, so that it's easy to read even on big screens.</b></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur</p>"
      }
    }
  }]
}, No = {
  name: "Slot",
  isRSC: !0,
  description: "Allow child blocks to be inserted into this content when used as a Symbol",
  docsLink: "https://www.builder.io/c/docs/symbols-with-blocks",
  image: "https://cdn.builder.io/api/v1/image/assets%2FYJIGb4i01jvw0SRdL5Bt%2F3aad6de36eae43b59b52c85190fdef56",
  // Maybe wrap this for canHaveChildren so bind children to this hm
  inputs: [{
    name: "name",
    type: "string",
    required: !0,
    defaultValue: "children"
  }],
  shouldReceiveBuilderProps: {
    builderContext: !0,
    builderComponents: !0
  }
}, Oo = b({
  name: "builder-slot",
  components: { Blocks: U },
  props: ["builderContext", "name", "builderComponents"]
});
function Fo(e, t, n, o, r, i) {
  var l, a, u;
  const s = k("Blocks");
  return c(), p("div", C(
    { style: {
      pointerEvents: "auto"
    } },
    !((l = e.builderContext.context) != null && l.symbolId) && {
      "builder-slot": e.name
    }
  ), [
    R(s, {
      parent: (a = e.builderContext.context) == null ? void 0 : a.symbolId,
      path: `symbol.data.${e.name}`,
      context: e.builderContext,
      registeredComponents: e.builderComponents,
      blocks: (u = e.builderContext.rootState) == null ? void 0 : u[e.name]
    }, null, 8, ["parent", "path", "context", "registeredComponents", "blocks"])
  ], 16);
}
const Do = /* @__PURE__ */ g(Oo, [["render", Fo]]), Lo = {
  name: "Symbol",
  noWrap: !0,
  static: !0,
  isRSC: !0,
  inputs: [{
    name: "symbol",
    type: "uiSymbol"
  }, {
    name: "dataOnly",
    helperText: "Make this a data symbol that doesn't display any UI",
    type: "boolean",
    defaultValue: !1,
    advanced: !0,
    hideFromUI: !0
  }, {
    name: "inheritState",
    helperText: "Inherit the parent component state and data",
    type: "boolean",
    defaultValue: !1,
    advanced: !0
  }, {
    name: "renderToLiquid",
    helperText: "Render this symbols contents to liquid. Turn off to fetch with javascript and use custom targeting",
    type: "boolean",
    defaultValue: !1,
    advanced: !0,
    hideFromUI: !0
  }, {
    name: "useChildren",
    hideFromUI: !0,
    type: "boolean"
  }],
  shouldReceiveBuilderProps: {
    builderBlock: !0,
    builderContext: !0,
    builderComponents: !0,
    builderLinkComponent: !0
  }
}, se = {
  "@type": "@builder.io/sdk:Element",
  responsiveStyles: {
    large: {
      paddingLeft: "20px",
      paddingRight: "20px",
      paddingTop: "10px",
      paddingBottom: "10px",
      minWidth: "100px",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      cursor: "pointer",
      userSelect: "none"
    }
  },
  component: {
    name: "Text",
    options: {
      text: "New tab"
    }
  }
}, ae = {
  "@type": "@builder.io/sdk:Element",
  responsiveStyles: {
    large: {
      height: "200px",
      display: "flex",
      marginTop: "20px",
      flexDirection: "column"
    }
  },
  component: {
    name: "Text",
    options: {
      text: "New tab content "
    }
  }
}, Uo = {
  name: "Builder: Tabs",
  inputs: [{
    name: "tabs",
    type: "list",
    broadcast: !0,
    subFields: [{
      name: "label",
      type: "uiBlocks",
      hideFromUI: !0,
      defaultValue: [se]
    }, {
      name: "content",
      type: "uiBlocks",
      hideFromUI: !0,
      defaultValue: [ae]
    }],
    defaultValue: [{
      label: [{
        ...se,
        component: {
          name: "Text",
          options: {
            text: "Tab 1"
          }
        }
      }],
      content: [{
        ...ae,
        component: {
          name: "Text",
          options: {
            text: "Tab 1 content"
          }
        }
      }]
    }, {
      label: [{
        ...se,
        component: {
          name: "Text",
          options: {
            text: "Tab 2"
          }
        }
      }],
      content: [{
        ...ae,
        component: {
          name: "Text",
          options: {
            text: "Tab 2 content"
          }
        }
      }]
    }]
  }, {
    name: "activeTabStyle",
    type: "uiStyle",
    helperText: "CSS styles for the active tab",
    defaultValue: {
      backgroundColor: "rgba(0, 0, 0, 0.1)"
    }
  }, {
    name: "defaultActiveTab",
    type: "number",
    helperText: 'Default tab to open to. Set to "1" for the first tab, "2" for the second, or choose "0" for none',
    defaultValue: 1,
    advanced: !0
  }, {
    name: "collapsible",
    type: "boolean",
    helperText: "If on, clicking an open tab closes it so no tabs are active",
    defaultValue: !1,
    advanced: !0
  }, {
    name: "tabHeaderLayout",
    type: "enum",
    helperText: "Change the layout of the tab headers (uses justify-content)",
    defaultValue: "flex-start",
    enum: [{
      label: "Center",
      value: "center"
    }, {
      label: "Space between",
      value: "space-between"
    }, {
      label: "Space around",
      value: "space-around"
    }, {
      label: "Left",
      value: "flex-start"
    }, {
      label: "Right",
      value: "flex-end"
    }]
  }],
  shouldReceiveBuilderProps: {
    builderBlock: !0,
    builderContext: !0,
    builderComponents: !0,
    builderLinkComponent: !0
  }
}, Mo = b({
  name: "builder-tabs",
  components: { Blocks: U },
  props: [
    "defaultActiveTab",
    "tabs",
    "collapsible",
    "tabHeaderLayout",
    "activeTabStyle",
    "builderBlock",
    "builderContext",
    "builderComponents",
    "builderLinkComponent"
  ],
  data() {
    return { activeTab: this.defaultActiveTab ? this.defaultActiveTab - 1 : 0 };
  },
  methods: {
    activeTabContent(e) {
      return this.tabs && this.tabs[e].content;
    },
    onClick(e) {
      e === this.activeTab && this.collapsible ? this.activeTab = -1 : this.activeTab = e;
    }
  }
}), Ho = ["onClick"], jo = { key: 0 };
function Ko(e, t, n, o, r, i) {
  const s = k("Blocks");
  return c(), p("div", null, [
    q("div", {
      class: "builder-tabs-wrap",
      style: F({
        display: "flex",
        flexDirection: "row",
        justifyContent: e.tabHeaderLayout || "flex-start",
        overflow: "auto"
      })
    }, [
      (c(!0), p(T, null, V(e.tabs, (l, a) => (c(), p("span", {
        key: a,
        class: z(`builder-tab-wrap ${e.activeTab === a ? "builder-tab-active" : ""}`),
        style: F({
          ...e.activeTab === a ? e.activeTabStyle : {}
        }),
        onClick: (u) => e.onClick(a)
      }, [
        R(s, {
          parent: e.builderBlock.id,
          path: `tabs.${a}.label`,
          blocks: l.label,
          context: e.builderContext,
          registeredComponents: e.builderComponents,
          linkComponent: e.builderLinkComponent
        }, null, 8, ["parent", "path", "blocks", "context", "registeredComponents", "linkComponent"])
      ], 14, Ho))), 128))
    ], 4),
    e.activeTabContent(e.activeTab) ? (c(), p("div", jo, [
      R(s, {
        parent: e.builderBlock.id,
        path: `tabs.${e.activeTab}.content`,
        blocks: e.activeTabContent(e.activeTab),
        context: e.builderContext,
        registeredComponents: e.builderComponents,
        linkComponent: e.builderLinkComponent
      }, null, 8, ["parent", "path", "blocks", "context", "registeredComponents", "linkComponent"])
    ])) : v("", !0)
  ]);
}
const qo = /* @__PURE__ */ g(Mo, [["render", Ko]]), zo = {
  shouldReceiveBuilderProps: {
    builderBlock: !1,
    builderContext: !0
  },
  name: "Text",
  static: !0,
  isRSC: !0,
  image: "https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/images%2Fbaseline-text_fields-24px%20(1).svg?alt=media&token=12177b73-0ee3-42ca-98c6-0dd003de1929",
  inputs: [{
    name: "text",
    type: "html",
    required: !0,
    autoFocus: !0,
    bubble: !0,
    defaultValue: "Enter some text..."
  }],
  defaultStyles: {
    lineHeight: "normal",
    height: "auto",
    textAlign: "center"
  }
}, Go = b({
  name: "builder-text",
  props: ["builderContext", "text"],
  computed: {
    processedText() {
      var i;
      const e = this.builderContext, {
        context: t,
        localState: n,
        rootState: o,
        rootSetState: r
      } = e;
      return String(((i = this.text) == null ? void 0 : i.toString()) || "").replace(
        /{{([^}]+)}}/g,
        (s, l) => J({
          code: l,
          context: t,
          localState: n,
          rootState: o,
          rootSetState: r
        })
      );
    }
  }
}), Jo = ["innerHTML"];
function Yo(e, t, n, o, r, i) {
  return c(), p("div", {
    class: "builder-text",
    innerHTML: e.processedText,
    style: {
      outline: "none"
    }
  }, null, 8, Jo);
}
const Xo = /* @__PURE__ */ g(Go, [["render", Yo]]), Qo = {
  name: "Custom Code",
  static: !0,
  requiredPermissions: ["editCode"],
  inputs: [{
    name: "code",
    type: "html",
    required: !0,
    defaultValue: "<p>Hello there, I am custom HTML code!</p>",
    code: !0
  }, {
    name: "replaceNodes",
    type: "boolean",
    helperText: "Preserve server rendered dom nodes",
    advanced: !0
  }, {
    name: "scriptsClientOnly",
    type: "boolean",
    defaultValue: !1,
    helperText: "Only print and run scripts on the client. Important when scripts influence DOM that could be replaced when client loads",
    advanced: !0
  }]
}, Zo = b({
  name: "builder-custom-code",
  props: ["replaceNodes", "code"],
  data() {
    return { scriptsInserted: [], scriptsRun: [] };
  },
  mounted() {
    var t;
    if (!((t = this.$refs.elementRef) != null && t.getElementsByTagName) || typeof window > "u")
      return;
    const e = this.$refs.elementRef.getElementsByTagName("script");
    for (let n = 0; n < e.length; n++) {
      const o = e[n];
      if (o.src) {
        if (this.scriptsInserted.includes(o.src))
          continue;
        this.scriptsInserted.push(o.src);
        const r = document.createElement("script");
        r.async = !0, r.src = o.src, document.head.appendChild(r);
      } else if (!o.type || [
        "text/javascript",
        "application/javascript",
        "application/ecmascript"
      ].includes(o.type)) {
        if (this.scriptsRun.includes(o.innerText))
          continue;
        try {
          this.scriptsRun.push(o.innerText), new Function(o.innerText)();
        } catch (r) {
          console.warn("`CustomCode`: Error running script:", r);
        }
      }
    }
  }
}), _o = ["innerHTML"];
function er(e, t, n, o, r, i) {
  return c(), p("div", {
    ref: "elementRef",
    class: z("builder-custom-code" + (e.replaceNodes ? " replace-nodes" : "")),
    innerHTML: e.code
  }, null, 10, _o);
}
const tr = /* @__PURE__ */ g(Zo, [["render", er]]), nr = {
  name: "Embed",
  static: !0,
  inputs: [{
    name: "url",
    type: "url",
    required: !0,
    defaultValue: "",
    helperText: "e.g. enter a youtube url, google map, etc"
  }, {
    name: "content",
    type: "html",
    defaultValue: '<div style="padding: 20px; text-align: center">(Choose an embed URL)<div>',
    hideFromUI: !0
  }]
}, or = ["text/javascript", "application/javascript", "application/ecmascript"], rr = (e) => or.includes(e.type), ir = b({
  name: "builder-embed",
  props: ["content"],
  data() {
    return { scriptsInserted: [], scriptsRun: [], ranInitFn: !1 };
  },
  watch: {
    onUpdateHook0: {
      handler() {
        this.$refs.elem && !this.ranInitFn && (this.ranInitFn = !0, this.findAndRunScripts());
      },
      immediate: !0
    }
  },
  computed: {
    onUpdateHook0() {
      return {
        0: this.$refs.elem,
        1: this.ranInitFn
      };
    }
  },
  methods: {
    findAndRunScripts() {
      if (!this.$refs.elem || !this.$refs.elem.getElementsByTagName)
        return;
      const e = this.$refs.elem.getElementsByTagName("script");
      for (let t = 0; t < e.length; t++) {
        const n = e[t];
        if (n.src && !this.scriptsInserted.includes(n.src)) {
          this.scriptsInserted.push(n.src);
          const o = document.createElement("script");
          o.async = !0, o.src = n.src, document.head.appendChild(o);
        } else if (rr(n) && !this.scriptsRun.includes(n.innerText))
          try {
            this.scriptsRun.push(n.innerText), new Function(n.innerText)();
          } catch (o) {
            console.warn("`Embed`: Error running script:", o);
          }
      }
    }
  }
}), sr = ["innerHTML"];
function ar(e, t, n, o, r, i) {
  return c(), p("div", {
    class: "builder-embed",
    ref: "elem",
    innerHTML: e.content
  }, null, 8, sr);
}
const lr = /* @__PURE__ */ g(ir, [["render", ar]]), cr = {
  name: "Form:Form",
  // editableTags: ['builder-form-error']
  defaults: {
    responsiveStyles: {
      large: {
        marginTop: "15px",
        paddingBottom: "15px"
      }
    }
  },
  image: "https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2Fef36d2a846134910b64b88e6d18c5ca5",
  inputs: [{
    name: "sendSubmissionsTo",
    type: "string",
    // TODO: save to builder data and user can download as csv
    // TODO: easy for mode too or computed add/remove fields form mode
    // so you can edit details and high level mode at same time...
    // Later - more integrations like mailchimp
    // /api/v1/form-submit?to=mailchimp
    enum: [{
      label: "Send to email",
      value: "email",
      helperText: "Send form submissions to the email address of your choosing"
    }, {
      label: "Custom",
      value: "custom",
      helperText: "Handle where the form requests go manually with a little code, e.g. to your own custom backend"
    }],
    defaultValue: "email"
  }, {
    name: "sendSubmissionsToEmail",
    type: "string",
    required: !0,
    // TODO: required: () => options.get("sendSubmissionsTo") === "email"
    defaultValue: "your@email.com",
    showIf: 'options.get("sendSubmissionsTo") === "email"'
  }, {
    name: "sendWithJs",
    type: "boolean",
    helperText: "Set to false to use basic html form action",
    defaultValue: !0,
    showIf: 'options.get("sendSubmissionsTo") === "custom"'
  }, {
    name: "name",
    type: "string",
    defaultValue: "My form"
    // advanced: true
  }, {
    name: "action",
    type: "string",
    helperText: "URL to send the form data to",
    showIf: 'options.get("sendSubmissionsTo") === "custom"'
  }, {
    name: "contentType",
    type: "string",
    defaultValue: "application/json",
    advanced: !0,
    // TODO: do automatically if file input
    enum: ["application/json", "multipart/form-data", "application/x-www-form-urlencoded"],
    showIf: 'options.get("sendSubmissionsTo") === "custom" && options.get("sendWithJs") === true'
  }, {
    name: "method",
    type: "string",
    showIf: 'options.get("sendSubmissionsTo") === "custom"',
    defaultValue: "POST",
    advanced: !0
  }, {
    name: "previewState",
    type: "string",
    // TODO: persist: false flag
    enum: ["unsubmitted", "sending", "success", "error"],
    defaultValue: "unsubmitted",
    helperText: 'Choose a state to edit, e.g. choose "success" to show what users see on success and edit the message',
    showIf: 'options.get("sendSubmissionsTo") !== "zapier" && options.get("sendWithJs") === true'
  }, {
    name: "successUrl",
    type: "url",
    helperText: "Optional URL to redirect the user to on form submission success",
    showIf: 'options.get("sendSubmissionsTo") !== "zapier" && options.get("sendWithJs") === true'
  }, {
    name: "resetFormOnSubmit",
    type: "boolean",
    showIf: "options.get('sendSubmissionsTo') === 'custom' && options.get('sendWithJs') === true",
    advanced: !0
  }, {
    name: "successMessage",
    type: "uiBlocks",
    hideFromUI: !0,
    defaultValue: [{
      "@type": "@builder.io/sdk:Element",
      responsiveStyles: {
        large: {
          marginTop: "10px"
        }
      },
      component: {
        name: "Text",
        options: {
          text: "<span>Thanks!</span>"
        }
      }
    }]
  }, {
    name: "validate",
    type: "boolean",
    defaultValue: !0,
    advanced: !0
  }, {
    name: "errorMessagePath",
    type: "text",
    advanced: !0,
    helperText: 'Path to where to get the error message from in a JSON response to display to the user, e.g. "error.message" for a response like { "error": { "message": "this username is taken" }}'
  }, {
    name: "errorMessage",
    type: "uiBlocks",
    hideFromUI: !0,
    defaultValue: [{
      "@type": "@builder.io/sdk:Element",
      responsiveStyles: {
        large: {
          marginTop: "10px"
        }
      },
      bindings: {
        "component.options.text": "state.formErrorMessage || block.component.options.text"
      },
      component: {
        name: "Text",
        options: {
          text: "<span>Form submission error :( Please check your answers and try again</span>"
        }
      }
    }]
  }, {
    name: "sendingMessage",
    type: "uiBlocks",
    hideFromUI: !0,
    defaultValue: [{
      "@type": "@builder.io/sdk:Element",
      responsiveStyles: {
        large: {
          marginTop: "10px"
        }
      },
      component: {
        name: "Text",
        options: {
          text: "<span>Sending...</span>"
        }
      }
    }]
  }, {
    name: "customHeaders",
    type: "map",
    valueType: {
      type: "string"
    },
    advanced: !0,
    showIf: 'options.get("sendSubmissionsTo") === "custom" && options.get("sendWithJs") === true'
  }],
  noWrap: !0,
  canHaveChildren: !0,
  defaultChildren: [{
    "@type": "@builder.io/sdk:Element",
    responsiveStyles: {
      large: {
        marginTop: "10px"
      }
    },
    component: {
      name: "Text",
      options: {
        text: "<span>Enter your name</span>"
      }
    }
  }, {
    "@type": "@builder.io/sdk:Element",
    responsiveStyles: {
      large: {
        marginTop: "10px"
      }
    },
    component: {
      name: "Form:Input",
      options: {
        name: "name",
        placeholder: "Jane Doe"
      }
    }
  }, {
    "@type": "@builder.io/sdk:Element",
    responsiveStyles: {
      large: {
        marginTop: "10px"
      }
    },
    component: {
      name: "Text",
      options: {
        text: "<span>Enter your email</span>"
      }
    }
  }, {
    "@type": "@builder.io/sdk:Element",
    responsiveStyles: {
      large: {
        marginTop: "10px"
      }
    },
    component: {
      name: "Form:Input",
      options: {
        name: "email",
        placeholder: "jane@doe.com"
      }
    }
  }, {
    "@type": "@builder.io/sdk:Element",
    responsiveStyles: {
      large: {
        marginTop: "10px"
      }
    },
    component: {
      name: "Form:SubmitButton",
      options: {
        text: "Submit"
      }
    }
  }],
  shouldReceiveBuilderProps: {
    builderBlock: !0,
    builderContext: !0,
    builderComponents: !0,
    builderLinkComponent: !0
  }
}, dr = ["production", "qa", "test", "development", "dev", "cdn-qa", "cloud", "fast", "cdn2", "cdn-prod"], ur = () => {
  const e = process.env.NODE_ENV || "production";
  return dr.includes(e) ? e : "production";
}, pr = b({
  name: "builder-form-component",
  components: { Block: ke, Blocks: U },
  props: [
    "builderContext",
    "previewState",
    "sendWithJs",
    "sendSubmissionsTo",
    "action",
    "customHeaders",
    "contentType",
    "sendSubmissionsToEmail",
    "name",
    "method",
    "errorMessagePath",
    "resetFormOnSubmit",
    "successUrl",
    "validate",
    "attributes",
    "builderBlock",
    "builderComponents",
    "builderLinkComponent",
    "errorMessage",
    "sendingMessage",
    "successMessage"
  ],
  data() {
    return {
      formState: "unsubmitted",
      responseData: null,
      formErrorMessage: "",
      filterAttrs: W
    };
  },
  methods: {
    mergeNewRootState(e) {
      var n, o;
      const t = {
        ...this.builderContext.rootState,
        ...e
      };
      this.builderContext.rootSetState ? (o = (n = this.builderContext).rootSetState) == null || o.call(n, t) : this.builderContext.rootState = t;
    },
    submissionState() {
      return B() && this.previewState || this.formState;
    },
    onSubmit(e) {
      var n;
      const t = this.sendWithJs || this.sendSubmissionsTo === "email";
      if (this.sendSubmissionsTo === "zapier")
        e.preventDefault();
      else if (t) {
        if (!(this.action || this.sendSubmissionsTo === "email")) {
          e.preventDefault();
          return;
        }
        e.preventDefault();
        const o = e.currentTarget || e.target, r = this.customHeaders || {};
        let i;
        const s = new FormData(o), l = Array.from(o.querySelectorAll("input,select,textarea")).filter((d) => !!d.name).map((d) => {
          let f;
          const S = d.name;
          if (d instanceof HTMLInputElement)
            if (d.type === "radio") {
              if (d.checked)
                return f = d.name, {
                  key: S,
                  value: f
                };
            } else if (d.type === "checkbox")
              f = d.checked;
            else if (d.type === "number" || d.type === "range") {
              const w = d.valueAsNumber;
              isNaN(w) || (f = w);
            } else
              d.type === "file" ? f = d.files : f = d.value;
          else
            f = d.value;
          return {
            key: S,
            value: f
          };
        });
        let a = this.contentType;
        if (this.sendSubmissionsTo === "email" && (a = "multipart/form-data"), Array.from(l).forEach(({ value: d }) => {
          (d instanceof File || Array.isArray(d) && d[0] instanceof File || d instanceof FileList) && (a = "multipart/form-data");
        }), a !== "application/json")
          i = s;
        else {
          const d = {};
          Array.from(l).forEach(({ value: f, key: S }) => {
            Le(d, S, f);
          }), i = JSON.stringify(d);
        }
        a && a !== "multipart/form-data" && (t && ((n = this.action) != null && n.includes("zapier.com")) || (r["content-type"] = a));
        const u = new CustomEvent("presubmit", {
          detail: {
            body: i
          }
        });
        if (this.$refs.formRef && (this.$refs.formRef.dispatchEvent(u), u.defaultPrevented))
          return;
        this.formState = "sending";
        const m = `${ur() === "dev" ? "http://localhost:5000" : "https://builder.io"}/api/v1/form-submit?apiKey=${this.builderContext.apiKey}&to=${btoa(
          this.sendSubmissionsToEmail || ""
        )}&name=${encodeURIComponent(this.name || "")}`, h = this.sendSubmissionsTo === "email" ? m : this.action;
        he(h), fetch(h, {
          body: i,
          headers: r,
          method: this.method || "post"
        }).then(
          async (d) => {
            let f;
            const S = d.headers.get("content-type");
            if (S && S.indexOf("application/json") !== -1 ? f = await d.json() : f = await d.text(), !d.ok && this.errorMessagePath) {
              let w = We(f, this.errorMessagePath);
              w && (typeof w != "string" && (w = JSON.stringify(w)), this.formErrorMessage = w, this.mergeNewRootState({
                formErrorMessage: w
              }));
            }
            if (this.responseData = f, this.formState = d.ok ? "success" : "error", d.ok) {
              const w = new CustomEvent("submit:success", {
                detail: {
                  res: d,
                  body: f
                }
              });
              if (this.$refs.formRef) {
                if (this.$refs.formRef.dispatchEvent(w), w.defaultPrevented)
                  return;
                this.resetFormOnSubmit !== !1 && this.$refs.formRef.reset();
              }
              if (this.successUrl)
                if (this.$refs.formRef) {
                  const L = new CustomEvent("route", {
                    detail: {
                      url: this.successUrl
                    }
                  });
                  this.$refs.formRef.dispatchEvent(L), L.defaultPrevented || (location.href = this.successUrl);
                } else
                  location.href = this.successUrl;
            }
          },
          (d) => {
            const f = new CustomEvent("submit:error", {
              detail: {
                error: d
              }
            });
            this.$refs.formRef && (this.$refs.formRef.dispatchEvent(f), f.defaultPrevented) || (this.responseData = d, this.formState = "error");
          }
        );
      }
    }
  }
}), mr = ["validate", "action", "method", "name"], hr = {
  key: 3,
  class: "builder-form-error-text pre-3q96myty4lk"
};
function fr(e, t, n, o, r, i) {
  var a;
  const s = k("Block"), l = k("Blocks");
  return c(), p("form", C({
    validate: e.validate,
    ref: "formRef",
    action: !e.sendWithJs && e.action,
    method: e.method,
    name: e.name,
    onSubmit: t[0] || (t[0] = (u) => e.onSubmit(u))
  }, { ...e.filterAttrs(e.attributes, "v-on:", !1) }, x(e.filterAttrs(e.attributes, "v-on:", !0), !0)), [
    e.builderBlock && e.builderBlock.children ? (c(!0), p(T, { key: 0 }, V((a = e.builderBlock) == null ? void 0 : a.children, (u, m) => (c(), y(s, {
      key: `form-block-${e.idx}`,
      block: u,
      context: e.builderContext,
      registeredComponents: e.builderComponents,
      linkComponent: e.builderLinkComponent
    }, null, 8, ["block", "context", "registeredComponents", "linkComponent"]))), 128)) : v("", !0),
    e.submissionState() === "error" ? (c(), y(l, {
      key: 1,
      path: "errorMessage",
      blocks: e.errorMessage,
      context: e.builderContext
    }, null, 8, ["blocks", "context"])) : v("", !0),
    e.submissionState() === "sending" ? (c(), y(l, {
      key: 2,
      path: "sendingMessage",
      blocks: e.sendingMessage,
      context: e.builderContext
    }, null, 8, ["blocks", "context"])) : v("", !0),
    e.submissionState() === "error" && e.responseData ? (c(), p("pre", hr, te(JSON.stringify(e.responseData, null, 2)), 1)) : v("", !0),
    e.submissionState() === "success" ? (c(), y(l, {
      key: 4,
      path: "successMessage",
      blocks: e.successMessage,
      context: e.builderContext
    }, null, 8, ["blocks", "context"])) : v("", !0)
  ], 16, mr);
}
const br = /* @__PURE__ */ g(pr, [["render", fr], ["__scopeId", "data-v-cd94d6c1"]]), gr = {
  name: "Form:Input",
  image: "https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2Fad6f37889d9e40bbbbc72cdb5875d6ca",
  inputs: [
    {
      name: "type",
      type: "text",
      enum: ["text", "number", "email", "url", "checkbox", "radio", "range", "date", "datetime-local", "search", "tel", "time", "file", "month", "week", "password", "color", "hidden"],
      defaultValue: "text"
    },
    {
      name: "name",
      type: "string",
      required: !0,
      helperText: 'Every input in a form needs a unique name describing what it takes, e.g. "email"'
    },
    {
      name: "placeholder",
      type: "string",
      defaultValue: "Hello there",
      helperText: "Text to display when there is no value"
    },
    // TODO: handle value vs default value automatically like ng-model
    {
      name: "defaultValue",
      type: "string"
    },
    {
      name: "value",
      type: "string",
      advanced: !0
    },
    {
      name: "required",
      type: "boolean",
      helperText: "Is this input required to be filled out to submit a form",
      defaultValue: !1
    }
  ],
  noWrap: !0,
  static: !0,
  defaultStyles: {
    paddingTop: "10px",
    paddingBottom: "10px",
    paddingLeft: "10px",
    paddingRight: "10px",
    borderRadius: "3px",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "#ccc"
  }
}, yr = b({
  name: "builder-form-input-component",
  props: [
    "attributes",
    "defaultValue",
    "placeholder",
    "type",
    "name",
    "value",
    "required"
  ],
  data() {
    return { isEditing: B, filterAttrs: W };
  }
}), kr = ["placeholder", "type", "name", "value", "defaultValue", "required"];
function vr(e, t, n, o, r, i) {
  return c(), p("input", C({
    key: e.isEditing() && e.defaultValue ? e.defaultValue : "default-key",
    placeholder: e.placeholder,
    type: e.type,
    name: e.name,
    value: e.value,
    defaultValue: e.defaultValue,
    required: e.required
  }, e.filterAttrs(e.attributes, "v-on:", !1), x(e.filterAttrs(e.attributes, "v-on:", !0), !0)), null, 16, kr);
}
const Sr = /* @__PURE__ */ g(yr, [["render", vr]]), Cr = {
  name: "Form:Select",
  image: "https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2F83acca093fb24aaf94dee136e9a4b045",
  defaultStyles: {
    alignSelf: "flex-start"
  },
  inputs: [{
    name: "options",
    type: "list",
    required: !0,
    subFields: [{
      name: "value",
      type: "text",
      required: !0
    }, {
      name: "name",
      type: "text"
    }],
    defaultValue: [{
      value: "option 1"
    }, {
      value: "option 2"
    }]
  }, {
    name: "name",
    type: "string",
    required: !0,
    helperText: 'Every select in a form needs a unique name describing what it gets, e.g. "email"'
  }, {
    name: "defaultValue",
    type: "string"
  }, {
    name: "value",
    type: "string",
    advanced: !0
  }, {
    name: "required",
    type: "boolean",
    defaultValue: !1
  }],
  static: !0,
  noWrap: !0
}, wr = b({
  name: "builder-select-component",
  props: ["attributes", "value", "defaultValue", "name", "required", "options"],
  data() {
    return { isEditing: B, filterAttrs: W };
  }
}), Tr = ["value", "defaultValue", "name", "required"], Ir = ["value"];
function $r(e, t, n, o, r, i) {
  return c(), p("select", C({
    value: e.value,
    key: e.isEditing() && e.defaultValue ? e.defaultValue : "default-key",
    defaultValue: e.defaultValue,
    name: e.name,
    required: e.required
  }, e.filterAttrs(e.attributes, "v-on:", !1), x(e.filterAttrs(e.attributes, "v-on:", !0), !0)), [
    (c(!0), p(T, null, V(e.options, (s, l) => (c(), p("option", {
      key: `${s.name}-${l}`,
      value: s.value
    }, te(s.name || s.value), 9, Ir))), 128))
  ], 16, Tr);
}
const Rr = /* @__PURE__ */ g(wr, [["render", $r]]), Er = {
  name: "Form:SubmitButton",
  image: "https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2Fdf2820ffed1f4349a94c40b3221f5b98",
  defaultStyles: {
    appearance: "none",
    paddingTop: "15px",
    paddingBottom: "15px",
    paddingLeft: "25px",
    paddingRight: "25px",
    backgroundColor: "#3898EC",
    color: "white",
    borderRadius: "4px",
    cursor: "pointer"
  },
  inputs: [{
    name: "text",
    type: "text",
    defaultValue: "Click me"
  }],
  static: !0,
  noWrap: !0
  // TODO: optional children? maybe as optional form input
  // that only shows if advanced setting is flipped
  // TODO: defaultChildren
  // canHaveChildren: true,
}, Pr = b({
  name: "builder-submit-button",
  props: ["attributes", "text"],
  data() {
    return { filterAttrs: W };
  }
});
function Br(e, t, n, o, r, i) {
  return c(), p("button", C({ type: "submit" }, e.filterAttrs(e.attributes, "v-on:", !1), x(e.filterAttrs(e.attributes, "v-on:", !0), !0)), te(e.text), 17);
}
const xr = /* @__PURE__ */ g(Pr, [["render", Br]]), Ar = {
  name: "Form:TextArea",
  image: "https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2Ff74a2f3de58c4c3e939204e5b6b8f6c3",
  inputs: [{
    advanced: !0,
    name: "value",
    type: "string"
  }, {
    name: "name",
    type: "string",
    required: !0,
    helperText: 'Every input in a form needs a unique name describing what it gets, e.g. "email"'
  }, {
    name: "defaultValue",
    type: "string"
  }, {
    name: "placeholder",
    type: "string",
    defaultValue: "Hello there"
  }, {
    name: "required",
    type: "boolean",
    defaultValue: !1
  }],
  defaultStyles: {
    paddingTop: "10px",
    paddingBottom: "10px",
    paddingLeft: "10px",
    paddingRight: "10px",
    borderRadius: "3px",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "#ccc"
  },
  static: !0,
  noWrap: !0
}, Vr = b({
  name: "builder-textarea",
  props: [
    "attributes",
    "placeholder",
    "name",
    "value",
    "defaultValue",
    "required"
  ],
  data() {
    return { filterAttrs: W };
  }
}), Wr = ["placeholder", "name", "value", "defaultValue", "required"];
function Nr(e, t, n, o, r, i) {
  return c(), p("textarea", C({
    placeholder: e.placeholder,
    name: e.name,
    value: e.value,
    defaultValue: e.defaultValue,
    required: e.required
  }, e.filterAttrs(e.attributes, "v-on:", !1), x(e.filterAttrs(e.attributes, "v-on:", !0), !0)), null, 16, Wr);
}
const Or = /* @__PURE__ */ g(Vr, [["render", Nr]]), Fr = {
  // friendlyName?
  name: "Raw:Img",
  hideFromInsertMenu: !0,
  image: "https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/images%2Fbaseline-insert_photo-24px.svg?alt=media&token=4e5d0ef4-f5e8-4e57-b3a9-38d63a9b9dc4",
  inputs: [{
    name: "image",
    bubble: !0,
    type: "file",
    allowedFileTypes: ["jpeg", "jpg", "png", "svg", "gif", "webp"],
    required: !0
  }],
  noWrap: !0,
  static: !0
}, Dr = b({
  name: "builder-img-component",
  props: [
    "backgroundSize",
    "backgroundPosition",
    "imgSrc",
    "altText",
    "image",
    "attributes"
  ],
  data() {
    return { isEditing: B, filterAttrs: W };
  }
}), Lr = ["alt", "src"];
function Ur(e, t, n, o, r, i) {
  return c(), p("img", C({
    style: {
      objectFit: e.backgroundSize || "cover",
      objectPosition: e.backgroundPosition || "center"
    },
    key: e.isEditing() && e.imgSrc || "default-key",
    alt: e.altText,
    src: e.imgSrc || e.image
  }, e.filterAttrs(e.attributes, "v-on:", !1), x(e.filterAttrs(e.attributes, "v-on:", !0), !0)), null, 16, Lr);
}
const Mr = /* @__PURE__ */ g(Dr, [["render", Ur]]), Hr = {
  name: "Video",
  canHaveChildren: !0,
  defaultStyles: {
    minHeight: "20px",
    minWidth: "20px"
  },
  image: "https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/images%2Fbaseline-videocam-24px%20(1).svg?alt=media&token=49a84e4a-b20e-4977-a650-047f986874bb",
  inputs: [{
    name: "video",
    type: "file",
    allowedFileTypes: ["mp4"],
    bubble: !0,
    defaultValue: "https://cdn.builder.io/o/assets%2FYJIGb4i01jvw0SRdL5Bt%2Fd27731a526464deba0016216f5f9e570%2Fcompressed?apiKey=YJIGb4i01jvw0SRdL5Bt&token=d27731a526464deba0016216f5f9e570&alt=media&optimized=true",
    required: !0
  }, {
    name: "posterImage",
    type: "file",
    allowedFileTypes: ["jpeg", "png"],
    helperText: "Image to show before the video plays"
  }, {
    name: "autoPlay",
    type: "boolean",
    defaultValue: !0
  }, {
    name: "controls",
    type: "boolean",
    defaultValue: !1
  }, {
    name: "muted",
    type: "boolean",
    defaultValue: !0
  }, {
    name: "loop",
    type: "boolean",
    defaultValue: !0
  }, {
    name: "playsInline",
    type: "boolean",
    defaultValue: !0
  }, {
    name: "fit",
    type: "text",
    defaultValue: "cover",
    enum: ["contain", "cover", "fill", "auto"]
  }, {
    name: "preload",
    type: "text",
    defaultValue: "metadata",
    enum: ["auto", "metadata", "none"]
  }, {
    name: "fitContent",
    type: "boolean",
    helperText: "When child blocks are provided, fit to them instead of using the aspect ratio",
    defaultValue: !0,
    advanced: !0
  }, {
    name: "position",
    type: "text",
    defaultValue: "center",
    enum: ["center", "top", "left", "right", "bottom", "top left", "top right", "bottom left", "bottom right"]
  }, {
    name: "height",
    type: "number",
    advanced: !0
  }, {
    name: "width",
    type: "number",
    advanced: !0
  }, {
    name: "aspectRatio",
    type: "number",
    advanced: !0,
    defaultValue: 0.7004048582995948
  }, {
    name: "lazyLoad",
    type: "boolean",
    helperText: 'Load this video "lazily" - as in only when a user scrolls near the video. Recommended for optmized performance and bandwidth consumption',
    defaultValue: !0,
    advanced: !0
  }],
  shouldReceiveBuilderProps: {
    builderBlock: !0
  }
}, jr = b({
  name: "builder-video",
  props: [
    "autoPlay",
    "muted",
    "controls",
    "loop",
    "playsInline",
    "preload",
    "attributes",
    "fit",
    "position",
    "aspectRatio",
    "video",
    "posterImage",
    "lazyLoad",
    "fitContent",
    "builderBlock"
  ],
  computed: {
    videoProps() {
      return {
        ...this.autoPlay === !0 ? {
          autoPlay: !0
        } : {},
        ...this.muted === !0 ? {
          muted: !0
        } : {},
        ...this.controls === !0 ? {
          controls: !0
        } : {},
        ...this.loop === !0 ? {
          loop: !0
        } : {},
        ...this.playsInline === !0 ? {
          playsInline: !0
        } : {}
      };
    },
    spreadProps() {
      return {
        ...this.videoProps
      };
    }
  }
}), Kr = { style: {
  position: "relative"
} }, qr = ["preload", "src", "poster"], zr = ["src"], Gr = {
  key: 1,
  style: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch"
  }
}, Jr = {
  key: 2,
  style: {
    pointerEvents: "none",
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    position: "absolute",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%"
  }
};
function Yr(e, t, n, o, r, i) {
  var s, l, a, u, m, h, d;
  return c(), p("div", Kr, [
    q("video", C({
      class: "builder-video",
      preload: e.preload || "metadata",
      style: {
        width: "100%",
        height: "100%",
        ...(s = e.attributes) == null ? void 0 : s.style,
        objectFit: e.fit,
        objectPosition: e.position,
        // Hack to get object fit to work as expected and
        // not have the video overflow
        zIndex: 2,
        borderRadius: "1px",
        ...e.aspectRatio ? {
          position: "absolute"
        } : null
      },
      src: e.video || "no-src",
      poster: e.posterImage
    }, e.spreadProps), [
      e.lazyLoad ? v("", !0) : (c(), p("source", {
        key: 0,
        type: "video/mp4",
        src: e.video
      }, null, 8, zr))
    ], 16, qr),
    e.aspectRatio && !(e.fitContent && ((a = (l = e.builderBlock) == null ? void 0 : l.children) != null && a.length)) ? (c(), p("div", {
      key: 0,
      style: F({
        width: "100%",
        paddingTop: e.aspectRatio * 100 + "%",
        pointerEvents: "none",
        fontSize: "0px"
      })
    }, null, 4)) : v("", !0),
    (m = (u = e.builderBlock) == null ? void 0 : u.children) != null && m.length && e.fitContent ? (c(), p("div", Gr, [
      A(e.$slots, "default")
    ])) : v("", !0),
    (d = (h = e.builderBlock) == null ? void 0 : h.children) != null && d.length && !e.fitContent ? (c(), p("div", Jr, [
      A(e.$slots, "default")
    ])) : v("", !0)
  ]);
}
const Xr = /* @__PURE__ */ g(jr, [["render", Yr]]), Qr = () => [{
  component: tr,
  ...Qo
}, {
  component: lr,
  ...nr
}, {
  component: br,
  ...cr
}, {
  component: Sr,
  ...gr
}, {
  component: xr,
  ...Er
}, {
  component: Rr,
  ...Cr
}, {
  component: Or,
  ...Ar
}, {
  component: Mr,
  ...Fr
}, {
  component: Xr,
  ...Hr
}], Pe = () => [{
  component: Tt,
  ...Bo
}, {
  component: lo,
  ...xo
}, {
  component: po,
  ...Ao
}, {
  component: vo,
  ...Vo
}, {
  component: wo,
  ...Wo
}, {
  component: Do,
  ...No
}, {
  component: Ai,
  ...Lo
}, {
  component: Xo,
  ...zo
}, {
  component: qo,
  ...Uo
}, {
  component: Po,
  ...To
}, ...Qr()], Zr = `function updateCookiesAndStyles(contentId, variants, isHydrationTarget) {
  function getAndSetVariantId() {
    function setCookie(name, value, days) {
      let expires = '';
      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = '; expires=' + date.toUTCString();
      }
      document.cookie = name + '=' + (value || '') + expires + '; path=/' + '; Secure; SameSite=None';
    }
    function getCookie(name) {
      const nameEQ = name + '=';
      const ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    }
    const cookieName = \`builder.tests.\${contentId}\`;
    const variantInCookie = getCookie(cookieName);
    const availableIDs = variants.map(vr => vr.id).concat(contentId);
    if (variantInCookie && availableIDs.includes(variantInCookie)) {
      return variantInCookie;
    }
    let n = 0;
    const random = Math.random();
    for (let i = 0; i < variants.length; i++) {
      const variant = variants[i];
      const testRatio = variant.testRatio;
      n += testRatio;
      if (random < n) {
        setCookie(cookieName, variant.id);
        return variant.id;
      }
    }
    setCookie(cookieName, contentId);
    return contentId;
  }
  const winningVariantId = getAndSetVariantId();
  const styleEl = document.currentScript?.previousElementSibling;
  if (isHydrationTarget) {
    styleEl.remove();
    const thisScriptEl = document.currentScript;
    thisScriptEl?.remove();
  } else {
    const newStyleStr = variants.concat({
      id: contentId
    }).filter(variant => variant.id !== winningVariantId).map(value => {
      return \`.variant-\${value.id} {  display: none; }
        \`;
    }).join('');
    styleEl.innerHTML = newStyleStr;
  }
}`, _r = `function updateVariantVisibility(variantContentId, defaultContentId, isHydrationTarget) {
  if (!navigator.cookieEnabled) {
    return;
  }
  function getCookie(name) {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
  const cookieName = \`builder.tests.\${defaultContentId}\`;
  const winningVariant = getCookie(cookieName);
  const parentDiv = document.currentScript?.parentElement;
  const isDefaultContent = variantContentId === defaultContentId;
  const isWinningVariant = winningVariant === variantContentId;
  if (isWinningVariant && !isDefaultContent) {
    parentDiv?.removeAttribute('hidden');
    parentDiv?.removeAttribute('aria-hidden');
  } else if (!isWinningVariant && isDefaultContent) {
    parentDiv?.setAttribute('hidden', 'true');
    parentDiv?.setAttribute('aria-hidden', 'true');
  }
  if (isHydrationTarget) {
    if (!isWinningVariant) {
      parentDiv?.remove();
    }
    const thisScriptEl = document.currentScript;
    thisScriptEl?.remove();
  }
  return;
}`, ct = "builderIoAbTest", dt = "builderIoRenderContent", Z = (e) => Object.values((e == null ? void 0 : e.variations) || {}).map((t) => ({
  ...t,
  testVariationId: t.id,
  id: e == null ? void 0 : e.id
})), ei = ({
  canTrack: e,
  content: t
}) => !(!(Z(t).length > 0) || !e), ti = (e) => e === "react" || e === "reactNative", ut = ti(P), ni = () => `
  window.${ct} = ${Zr}
  window.${dt} = ${_r}
  `, oi = (e, t) => `
  window.${ct}(
    "${t}",${JSON.stringify(e)}, ${ut}
  )`, ri = ({
  contentId: e,
  variationId: t
}) => `window.${dt}(
    "${t}", "${e}", ${ut}
  )`, pt = b({
  render() {
    return Ae("script", {
      innerHTML: this.scriptStr,
      "data-id": this.id,
      nonce: this.nonce
    });
  },
  name: "inlined-script",
  props: ["scriptStr", "id", "nonce"]
});
function Be(e) {
  return Math.round(e * 1e3) / 1e3;
}
const ii = (e, t, n = !0) => {
  if (!(e instanceof HTMLElement))
    return null;
  let o = n ? e : e.parentElement;
  do {
    if (!o)
      return null;
    if (t(o))
      return o;
  } while (o = o.parentElement);
  return null;
}, si = (e) => ii(e, (t) => {
  const n = t.getAttribute("builder-id") || t.id;
  return (n == null ? void 0 : n.indexOf("builder-")) === 0;
}), xe = ({
  event: e,
  target: t
}) => {
  const n = t.getBoundingClientRect(), o = e.clientX - n.left, r = e.clientY - n.top, i = Be(o / n.width), s = Be(r / n.height);
  return {
    x: i,
    y: s
  };
}, ai = (e) => {
  const t = e.target, n = t && si(t), o = (n == null ? void 0 : n.getAttribute("builder-id")) || (n == null ? void 0 : n.id);
  return {
    targetBuilderElement: o || void 0,
    metadata: {
      targetOffset: t ? xe({
        event: e,
        target: t
      }) : void 0,
      builderTargetOffset: n ? xe({
        event: e,
        target: n
      }) : void 0,
      builderElementIndex: n && o ? [].slice.call(document.getElementsByClassName(o)).indexOf(n) : void 0
    }
  };
}, li = (e) => {
  var i;
  const t = e.family + (e.kind && !e.kind.includes("#") ? ", " + e.kind : ""), n = t.split(",")[0], o = e.fileUrl ?? ((i = e == null ? void 0 : e.files) == null ? void 0 : i.regular);
  let r = "";
  if (o && t && n && (r += `
@font-face {
font-family: "${t}";
src: local("${n}"), url('${o}') format('woff2');
font-display: fallback;
font-weight: 400;
}
      `.trim()), e.files)
    for (const s in e.files) {
      if (!(String(Number(s)) === s))
        continue;
      const a = e.files[s];
      a && a !== o && (r += `
@font-face {
font-family: "${t}";
src: url('${a}') format('woff2');
font-display: fallback;
font-weight: ${s};
}
        `.trim());
    }
  return r;
}, ci = ({
  customFonts: e
}) => {
  var t;
  return ((t = e == null ? void 0 : e.map((n) => li(n))) == null ? void 0 : t.join(" ")) || "";
}, di = ({
  cssCode: e,
  contentId: t
}) => e ? t ? (e == null ? void 0 : e.replace(/&/g, `div[builder-content-id="${t}"]`)) || "" : e : "", ui = `
.builder-button {
  all: unset;
}

.builder-text > p:first-of-type, .builder-text > .builder-paragraph:first-of-type {
  margin: 0;
}
.builder-text > p, .builder-text > .builder-paragraph {
  color: inherit;
  line-height: inherit;
  letter-spacing: inherit;
  font-weight: inherit;
  font-size: inherit;
  text-align: inherit;
  font-family: inherit;
}
`, pi = (e) => e ? "" : ui, mi = (e) => `variant-${e}`, hi = b({
  name: "enable-editor",
  components: { DynamicDiv: Y },
  props: [
    "isNestedRender",
    "builderContextSignal",
    "canTrack",
    "apiKey",
    "apiHost",
    "locale",
    "enrich",
    "trustedHosts",
    "model",
    "content",
    "data",
    "showContent",
    "contentWrapper",
    "context",
    "contentWrapperProps"
  ],
  data() {
    return {
      ContentWrapper: this.contentWrapper || "div",
      httpReqsData: {},
      httpReqsPending: {},
      clicked: !1,
      builderContext: le,
      getWrapperClassName: mi
    };
  },
  provide() {
    const e = this;
    return {
      [le.key]: e.builderContextSignal
    };
  },
  created() {
    this.runHttpRequests(), this.emitStateUpdate();
  },
  mounted() {
    var e, t;
    if ($()) {
      if (B() && !this.isNestedRender && this.$refs.elementRef && this.$refs.elementRef.dispatchEvent(
        new CustomEvent("initeditingbldr")
      ), this.builderContextSignal.content && G(this.canTrack)) {
        const o = (e = this.builderContextSignal.content) == null ? void 0 : e.testVariationId, r = (t = this.builderContextSignal.content) == null ? void 0 : t.id, i = this.apiKey;
        de({
          apiHost: this.apiHost,
          type: "impression",
          canTrack: !0,
          contentId: r,
          apiKey: i,
          variationId: o !== r ? o : void 0
        });
      }
      zt() && !B() && this.$refs.elementRef && this.$refs.elementRef.dispatchEvent(
        new CustomEvent("initpreviewingbldr")
      );
    }
  },
  watch: {
    onUpdateHook0: {
      handler() {
        this.content && this.mergeNewContent(this.content);
      },
      immediate: !0
    },
    onUpdateHook1: {
      handler() {
        this.emitStateUpdate();
      },
      immediate: !0
    },
    onUpdateHook2: {
      handler() {
        this.data && this.mergeNewRootState(this.data);
      },
      immediate: !0
    },
    onUpdateHook3: {
      handler() {
        this.locale && this.mergeNewRootState({
          locale: this.locale
        });
      },
      immediate: !0
    }
  },
  unmounted() {
    $() && (window.removeEventListener("message", this.processMessage), window.removeEventListener(
      "builder:component:stateChangeListenerActivated",
      this.emitStateUpdate
    ));
  },
  computed: {
    showContentProps() {
      return this.showContent ? {} : {
        hidden: !0,
        "aria-hidden": !0
      };
    },
    onUpdateHook0() {
      return {
        0: this.content
      };
    },
    onUpdateHook1() {
      return {
        0: this.builderContextSignal.rootState
      };
    },
    onUpdateHook2() {
      return {
        0: this.data
      };
    },
    onUpdateHook3() {
      return {
        0: this.locale
      };
    }
  },
  methods: {
    mergeNewRootState(e) {
      var n, o;
      const t = {
        ...this.builderContextSignal.rootState,
        ...e
      };
      this.builderContextSignal.rootSetState ? (o = (n = this.builderContextSignal).rootSetState) == null || o.call(n, t) : this.builderContextSignal.rootState = t;
    },
    mergeNewContent(e) {
      var n, o, r, i, s;
      const t = {
        ...this.builderContextSignal.content,
        ...e,
        data: {
          ...(n = this.builderContextSignal.content) == null ? void 0 : n.data,
          ...e == null ? void 0 : e.data
        },
        meta: {
          ...(o = this.builderContextSignal.content) == null ? void 0 : o.meta,
          ...e == null ? void 0 : e.meta,
          breakpoints: ((r = e == null ? void 0 : e.meta) == null ? void 0 : r.breakpoints) || ((s = (i = this.builderContextSignal.content) == null ? void 0 : i.meta) == null ? void 0 : s.breakpoints)
        }
      };
      this.builderContextSignal.content = t;
    },
    processMessage(e) {
      return Ze({
        model: this.model,
        trustedHosts: this.trustedHosts,
        callbacks: {
          configureSdk: (t) => {
            var r;
            const { breakpoints: n, contentId: o } = t;
            !o || o !== ((r = this.builderContextSignal.content) == null ? void 0 : r.id) || n && this.mergeNewContent({
              meta: {
                breakpoints: n
              }
            });
          },
          animation: (t) => {
            it(t);
          },
          contentUpdate: (t) => {
            this.mergeNewContent(t);
          }
        }
      })(e);
    },
    onClick(e) {
      var t, n;
      if (this.builderContextSignal.content) {
        const o = (t = this.builderContextSignal.content) == null ? void 0 : t.testVariationId, r = (n = this.builderContextSignal.content) == null ? void 0 : n.id;
        de({
          apiHost: this.apiHost,
          type: "click",
          canTrack: G(this.canTrack),
          contentId: r,
          apiKey: this.apiKey,
          variationId: o !== r ? o : void 0,
          ...ai(e),
          unique: !this.clicked
        });
      }
      this.clicked || (this.clicked = !0);
    },
    runHttpRequests() {
      var t, n;
      const e = ((n = (t = this.builderContextSignal.content) == null ? void 0 : t.data) == null ? void 0 : n.httpRequests) ?? {};
      Object.entries(e).forEach(([o, r]) => {
        if (!r || this.httpReqsPending[o] || this.httpReqsData[o] && !B())
          return;
        this.httpReqsPending[o] = !0;
        const i = r.replace(
          /{{([^}]+)}}/g,
          (s, l) => String(
            J({
              code: l,
              context: this.context || {},
              localState: void 0,
              rootState: this.builderContextSignal.rootState,
              rootSetState: this.builderContextSignal.rootSetState
            })
          )
        );
        he(i), fetch(i).then((s) => s.json()).then((s) => {
          this.mergeNewRootState({
            [o]: s
          }), this.httpReqsData[o] = !0;
        }).catch((s) => {
          console.error("error fetching dynamic data", r, s);
        }).finally(() => {
          this.httpReqsPending[o] = !1;
        });
      });
    },
    emitStateUpdate() {
      B() && window.dispatchEvent(
        new CustomEvent(
          "builder:component:stateChange",
          {
            detail: {
              state: me(this.builderContextSignal.rootState),
              ref: {
                name: this.model
              }
            }
          }
        )
      );
    },
    elementRef_onIniteditingbldr(e) {
      window.addEventListener("message", this.processMessage), fn(), Qe({
        ...this.locale ? {
          locale: this.locale
        } : {},
        ...this.enrich ? {
          enrich: this.enrich
        } : {},
        ...this.trustedHosts ? {
          trustedHosts: this.trustedHosts
        } : {}
      }), Object.values(
        this.builderContextSignal.componentInfos
      ).forEach((t) => {
        var o;
        const n = Gt(t);
        (o = window.parent) == null || o.postMessage(n, "*");
      }), window.addEventListener(
        "builder:component:stateChangeListenerActivated",
        this.emitStateUpdate
      );
    },
    elementRef_onInitpreviewingbldr(e) {
      const t = new URL(location.href).searchParams, n = t.get("builder.preview"), o = t.get(
        `builder.overrides.${n}`
      ), r = t.get("apiKey") || t.get("builder.space");
      n === this.model && r === this.apiKey && (!this.content || o === this.content.id) && ge({
        model: this.model,
        apiKey: this.apiKey,
        apiVersion: this.builderContextSignal.apiVersion
      }).then((i) => {
        i && this.mergeNewContent(i);
      });
    }
  }
});
function fi(e, t, n, o, r, i) {
  var s, l, a;
  return e.builderContextSignal.content ? (c(), y(j(e.ContentWrapper), C({
    key: 0,
    ref: "elementRef",
    onClick: (u) => e.onClick(u),
    "builder-content-id": (s = e.builderContextSignal.content) == null ? void 0 : s.id,
    "builder-model": e.model,
    className: e.getWrapperClassName(((l = e.content) == null ? void 0 : l.testVariationId) || ((a = e.content) == null ? void 0 : a.id)),
    onIniteditingbldr: (u) => e.elementRef_onIniteditingbldr(u),
    onInitpreviewingbldr: (u) => e.elementRef_onInitpreviewingbldr(u)
  }, { ...e.showContentProps, ...e.contentWrapperProps }), {
    default: N(() => [
      A(e.$slots, "default")
    ]),
    _: 3
  }, 16, ["onClick", "builder-content-id", "builder-model", "className", "onIniteditingbldr", "onInitpreviewingbldr"])) : v("", !0);
}
const bi = /* @__PURE__ */ g(hi, [["render", fi]]), gi = b({
  name: "content-styles",
  components: { InlinedStyles: ve },
  props: ["cssCode", "contentId", "customFonts", "isNestedRender", "nonce"],
  data() {
    return {
      injectedStyles: `
${di({
        cssCode: this.cssCode,
        contentId: this.contentId
      })}
${ci({
        customFonts: this.customFonts
      })}
${pi(this.isNestedRender)}
`.trim()
    };
  }
});
function yi(e, t, n, o, r, i) {
  const s = k("InlinedStyles");
  return c(), y(s, {
    id: "builderio-content",
    styles: e.injectedStyles,
    nonce: e.nonce
  }, null, 8, ["styles", "nonce"]);
}
const ki = /* @__PURE__ */ g(gi, [["render", yi]]), vi = ({
  content: e,
  data: t,
  locale: n
}) => {
  var i, s, l;
  const o = {}, r = ((i = e == null ? void 0 : e.data) == null ? void 0 : i.state) || {};
  return (l = (s = e == null ? void 0 : e.data) == null ? void 0 : s.inputs) == null || l.forEach((a) => {
    a.name && a.defaultValue !== void 0 && (o[a.name] = a.defaultValue);
  }), {
    ...o,
    ...r,
    ...t,
    ...n ? {
      locale: n
    } : {}
  };
}, Si = ({
  content: e,
  data: t
}) => e ? {
  ...e,
  data: {
    ...e == null ? void 0 : e.data,
    ...t
  },
  meta: e == null ? void 0 : e.meta
} : void 0, Ci = gt, wi = b({
  name: "content-component",
  components: {
    EnableEditor: bi,
    InlinedScript: pt,
    ContentStyles: ki,
    Blocks: U,
    DynamicDiv: Y
  },
  props: [
    "apiKey",
    "context",
    "content",
    "customComponents",
    "model",
    "data",
    "locale",
    "canTrack",
    "apiVersion",
    "blocksWrapper",
    "blocksWrapperProps",
    "nonce",
    "apiHost",
    "enrich",
    "showContent",
    "contentWrapper",
    "contentWrapperProps",
    "trustedHosts",
    "isNestedRender",
    "isSsrAbTest",
    "linkComponent"
  ],
  data() {
    var e, t, n, o;
    return {
      scriptStr: ri({
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-non-null-asserted-optional-chain
        variationId: (e = this.content) == null ? void 0 : e.testVariationId,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-non-null-asserted-optional-chain
        contentId: (t = this.content) == null ? void 0 : t.id
      }),
      registeredComponents: [
        ...Pe(),
        ...((n = this.customComponents) == null ? void 0 : n.filter(({ models: r }) => !(r != null && r.length) || !this.model ? !0 : r.includes(this.model))) || []
      ].reduce(
        (r, { component: i, ...s }) => ({
          ...r,
          [s.name]: {
            component: Ci(i),
            ...ee(s)
          }
        }),
        {}
      ),
      builderContextSignal: {
        content: Si({
          content: this.content,
          data: this.data
        }),
        localState: void 0,
        rootState: vi({
          content: this.content,
          data: this.data,
          locale: this.locale
        }),
        rootSetState: this.contentSetState,
        context: this.context || {},
        canTrack: this.canTrack,
        apiKey: this.apiKey,
        apiVersion: this.apiVersion,
        componentInfos: [
          ...Pe(),
          ...((o = this.customComponents) == null ? void 0 : o.filter(({ models: r }) => !(r != null && r.length) || !this.model ? !0 : r.includes(this.model))) || []
        ].reduce(
          (r, { component: i, ...s }) => ({
            ...r,
            [s.name]: ee(s)
          }),
          {}
        ),
        inheritedStyles: {},
        BlocksWrapper: this.blocksWrapper || "div",
        BlocksWrapperProps: this.blocksWrapperProps || {},
        nonce: this.nonce || ""
      },
      TARGET: P
    };
  },
  provide() {
    const e = this;
    return {
      [Ve.key]: {
        registeredComponents: e.registeredComponents
      }
    };
  },
  created() {
    var t, n;
    this.apiKey || E.error(
      "No API key provided to `Content` component. This can cause issues. Please provide an API key using the `apiKey` prop."
    );
    const e = (n = (t = this.builderContextSignal.content) == null ? void 0 : t.data) == null ? void 0 : n.jsCode;
    e && J({
      code: e,
      context: this.context || {},
      localState: void 0,
      rootState: this.builderContextSignal.rootState,
      rootSetState: (o) => {
        this.builderContextSignal.rootState = o;
      },
      isExpression: !1
    });
  },
  methods: {
    contentSetState(e) {
      this.builderContextSignal.rootState = e;
    }
  }
});
function Ti(e, t, n, o, r, i) {
  const s = k("InlinedScript"), l = k("ContentStyles"), a = k("Blocks"), u = k("EnableEditor");
  return c(), y(u, C({
    apiHost: e.apiHost,
    nonce: e.nonce,
    content: e.content,
    data: e.data,
    model: e.model,
    context: e.context,
    apiKey: e.apiKey,
    canTrack: e.canTrack,
    locale: e.locale,
    enrich: e.enrich,
    showContent: e.showContent,
    builderContextSignal: e.builderContextSignal,
    contentWrapper: e.contentWrapper,
    contentWrapperProps: e.contentWrapperProps,
    trustedHosts: e.trustedHosts,
    isNestedRender: e.isNestedRender
  }, {}), {
    default: N(() => {
      var m, h, d, f, S, w, L;
      return [
        e.isSsrAbTest ? (c(), y(s, {
          key: 0,
          id: "builderio-variant-visibility",
          scriptStr: e.scriptStr,
          nonce: e.nonce || ""
        }, null, 8, ["scriptStr", "nonce"])) : v("", !0),
        e.TARGET !== "reactNative" ? (c(), y(l, {
          key: 1,
          nonce: e.nonce || "",
          isNestedRender: e.isNestedRender,
          contentId: (m = e.builderContextSignal.content) == null ? void 0 : m.id,
          cssCode: (d = (h = e.builderContextSignal.content) == null ? void 0 : h.data) == null ? void 0 : d.cssCode,
          customFonts: (S = (f = e.builderContextSignal.content) == null ? void 0 : f.data) == null ? void 0 : S.customFonts
        }, null, 8, ["nonce", "isNestedRender", "contentId", "cssCode", "customFonts"])) : v("", !0),
        R(a, {
          blocks: (L = (w = e.builderContextSignal.content) == null ? void 0 : w.data) == null ? void 0 : L.blocks,
          context: e.builderContextSignal,
          registeredComponents: e.registeredComponents,
          linkComponent: e.linkComponent
        }, null, 8, ["blocks", "context", "registeredComponents", "linkComponent"])
      ];
    }),
    _: 1
  }, 16, ["apiHost", "nonce", "content", "data", "model", "context", "apiKey", "canTrack", "locale", "enrich", "showContent", "builderContextSignal", "contentWrapper", "contentWrapperProps", "trustedHosts", "isNestedRender"]);
}
const Ii = /* @__PURE__ */ g(wi, [["render", Ti]]), $i = b({
  name: "content-variants",
  components: {
    InlinedScript: pt,
    InlinedStyles: ve,
    ContentComponent: Ii
  },
  props: [
    "canTrack",
    "content",
    "isNestedRender",
    "nonce",
    "apiHost",
    "model",
    "data",
    "context",
    "apiKey",
    "apiVersion",
    "customComponents",
    "linkComponent",
    "locale",
    "enrich",
    "blocksWrapper",
    "blocksWrapperProps",
    "contentWrapper",
    "contentWrapperProps",
    "trustedHosts"
  ],
  data() {
    return {
      shouldRenderVariants: ei({
        canTrack: G(this.canTrack),
        content: this.content
      }),
      TARGET: P,
      getInitVariantsFnsScriptString: ni,
      getVariants: Z
    };
  },
  mounted() {
  },
  computed: {
    updateCookieAndStylesScriptStr() {
      var e;
      return oi(
        Z(this.content).map((t) => ({
          id: t.testVariationId,
          testRatio: t.testRatio
        })),
        ((e = this.content) == null ? void 0 : e.id) || ""
      );
    },
    hideVariantsStyleString() {
      return Z(this.content).map((e) => `.variant-${e.testVariationId} { display: none; } `).join("");
    },
    defaultContent() {
      var e;
      return this.shouldRenderVariants ? {
        ...this.content,
        testVariationId: (e = this.content) == null ? void 0 : e.id
      } : Sn({
        item: this.content,
        canTrack: G(this.canTrack)
      });
    }
  }
});
function Ri(e, t, n, o, r, i) {
  const s = k("InlinedScript"), l = k("InlinedStyles"), a = k("ContentComponent");
  return c(), p(T, null, [
    !e.isNestedRender && e.TARGET !== "reactNative" ? (c(), y(s, {
      key: 0,
      id: "builderio-init-variants-fns",
      scriptStr: e.getInitVariantsFnsScriptString(),
      nonce: e.nonce || ""
    }, null, 8, ["scriptStr", "nonce"])) : v("", !0),
    e.shouldRenderVariants ? (c(), p(T, { key: 1 }, [
      R(l, {
        id: "builderio-variants",
        styles: e.hideVariantsStyleString,
        nonce: e.nonce || ""
      }, null, 8, ["styles", "nonce"]),
      R(s, {
        id: "builderio-variants-visibility",
        scriptStr: e.updateCookieAndStylesScriptStr,
        nonce: e.nonce || ""
      }, null, 8, ["scriptStr", "nonce"]),
      (c(!0), p(T, null, V(e.getVariants(e.content), (u, m) => (c(), y(a, C({
        key: u.testVariationId,
        apiHost: e.apiHost,
        isNestedRender: e.isNestedRender,
        nonce: e.nonce,
        content: u,
        showContent: !1,
        model: e.model,
        data: e.data,
        context: e.context,
        apiKey: e.apiKey,
        apiVersion: e.apiVersion,
        customComponents: e.customComponents,
        linkComponent: e.linkComponent,
        canTrack: e.canTrack,
        locale: e.locale,
        enrich: e.enrich,
        isSsrAbTest: e.shouldRenderVariants,
        blocksWrapper: e.blocksWrapper,
        blocksWrapperProps: e.blocksWrapperProps,
        contentWrapper: e.contentWrapper,
        contentWrapperProps: e.contentWrapperProps,
        trustedHosts: e.trustedHosts
      }, {}), null, 16, ["apiHost", "isNestedRender", "nonce", "content", "model", "data", "context", "apiKey", "apiVersion", "customComponents", "linkComponent", "canTrack", "locale", "enrich", "isSsrAbTest", "blocksWrapper", "blocksWrapperProps", "contentWrapper", "contentWrapperProps", "trustedHosts"]))), 128))
    ], 64)) : v("", !0),
    R(a, C({
      apiHost: e.apiHost,
      nonce: e.nonce,
      isNestedRender: e.isNestedRender,
      content: e.defaultContent,
      showContent: !0,
      model: e.model,
      data: e.data,
      context: e.context,
      apiKey: e.apiKey,
      apiVersion: e.apiVersion,
      customComponents: e.customComponents,
      linkComponent: e.linkComponent,
      canTrack: e.canTrack,
      locale: e.locale,
      enrich: e.enrich,
      isSsrAbTest: e.shouldRenderVariants,
      blocksWrapper: e.blocksWrapper,
      blocksWrapperProps: e.blocksWrapperProps,
      contentWrapper: e.contentWrapper,
      contentWrapperProps: e.contentWrapperProps,
      trustedHosts: e.trustedHosts
    }, {
      key: e.shouldRenderVariants.toString()
    }), null, 16, ["apiHost", "nonce", "isNestedRender", "content", "model", "data", "context", "apiKey", "apiVersion", "customComponents", "linkComponent", "canTrack", "locale", "enrich", "isSsrAbTest", "blocksWrapper", "blocksWrapperProps", "contentWrapper", "contentWrapperProps", "trustedHosts"])
  ], 64);
}
const Ei = /* @__PURE__ */ g($i, [["render", Ri]]), Pi = async ({
  builderContextValue: e,
  symbol: t
}) => {
  if (t != null && t.model && // This is a hack, we should not need to check for this, but it is needed for Svelte.
  (e != null && e.apiKey))
    return ge({
      model: t.model,
      apiKey: e.apiKey,
      apiVersion: e.apiVersion,
      ...(t == null ? void 0 : t.entry) && {
        query: {
          id: t.entry
        }
      }
    }).catch((n) => {
      E.error("Could not fetch symbol content: ", n);
    });
}, Bi = b({
  name: "builder-symbol",
  components: { ContentVariants: Ei, DynamicDiv: Y },
  props: [
    "symbol",
    "attributes",
    "dynamic",
    "builderContext",
    "builderBlock",
    "builderComponents",
    "builderLinkComponent"
  ],
  data() {
    var e;
    return { contentToUse: (e = this.symbol) == null ? void 0 : e.content, filterAttrs: W };
  },
  mounted() {
    this.setContent();
  },
  watch: {
    onUpdateHook0: {
      handler() {
        this.setContent();
      },
      immediate: !0
    }
  },
  computed: {
    blocksWrapper() {
      return "div";
    },
    contentWrapper() {
      return "div";
    },
    className() {
      var e, t;
      return [
        this.attributes[_()],
        "builder-symbol",
        (e = this.symbol) != null && e.inline ? "builder-inline-symbol" : void 0,
        (t = this.symbol) != null && t.dynamic || this.dynamic ? "builder-dynamic-symbol" : void 0
      ].filter(Boolean).join(" ");
    },
    onUpdateHook0() {
      return {
        0: this.symbol
      };
    }
  },
  methods: {
    setContent() {
      this.contentToUse || Pi({
        symbol: this.symbol,
        builderContextValue: this.builderContext
      }).then((e) => {
        e && (this.contentToUse = e);
      });
    }
  }
});
function xi(e, t, n, o, r, i) {
  var l, a, u, m, h;
  const s = k("ContentVariants");
  return c(), p("div", C({ class: e.className }, { ...e.filterAttrs(e.attributes, "v-on:", !1) }, x(e.filterAttrs(e.attributes, "v-on:", !0), !0)), [
    R(s, {
      nonce: e.builderContext.nonce,
      isNestedRender: !0,
      apiVersion: e.builderContext.apiVersion,
      apiKey: e.builderContext.apiKey,
      context: {
        ...e.builderContext.context,
        symbolId: (l = e.builderBlock) == null ? void 0 : l.id
      },
      customComponents: Object.values(e.builderComponents),
      data: {
        ...(a = e.symbol) == null ? void 0 : a.data,
        ...e.builderContext.localState,
        ...(m = (u = e.contentToUse) == null ? void 0 : u.data) == null ? void 0 : m.state
      },
      canTrack: e.builderContext.canTrack,
      model: (h = e.symbol) == null ? void 0 : h.model,
      content: e.contentToUse,
      linkComponent: e.builderLinkComponent,
      blocksWrapper: e.blocksWrapper,
      contentWrapper: e.contentWrapper
    }, null, 8, ["nonce", "apiVersion", "apiKey", "context", "customComponents", "data", "canTrack", "model", "content", "linkComponent", "blocksWrapper", "contentWrapper"])
  ], 16);
}
const Ai = /* @__PURE__ */ g(Bi, [["render", xi]]);
export {
  Bn as A,
  ke as B,
  lo as C,
  ge as D,
  Ni as E,
  po as F,
  Hi as G,
  vo as I,
  wo as S,
  P as T,
  Xr as V,
  ve as _,
  Ui as a,
  ji as b,
  D as c,
  ye as d,
  g as e,
  J as f,
  ro as g,
  Mi as h,
  _ as i,
  le as j,
  Tt as k,
  Ai as l,
  Xo as m,
  U as n,
  Ei as o,
  B as p,
  zt as q,
  Gt as r,
  Yt as s,
  Oi as t,
  Ue as u,
  Fi as v,
  Ci as w,
  Di as x,
  Li as y,
  Pn as z
};
